/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/api/signature": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Signature
         * @description Get the user's signature
         */
        get: operations["get_signature"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** Sync Signature */
        patch: operations["sync_signature"];
        trace?: never;
    };
    "/api/draft_suggestion_change": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Draft Suggestion Change
         * @description Execute an autosuggestion specific to a draft message. For example: "Make the email funnier"
         */
        post: operations["draft_suggestion_change"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/rules": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List Rules */
        get: operations["list_rules"];
        put?: never;
        /** Create Rule */
        post: operations["create_rule"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/rules/{rule_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get Rule */
        get: operations["get_rule"];
        /** Update Rule */
        put: operations["update_rule"];
        post?: never;
        /** Delete Rule */
        delete: operations["delete_rule"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/me": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Me Get */
        get: operations["me_get"];
        put?: never;
        post?: never;
        /** Me Delete */
        delete: operations["me_delete"];
        options?: never;
        head?: never;
        /** Me Patch */
        patch: operations["me_patch"];
        trace?: never;
    };
    "/api/referral_code": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Update Referral Code */
        post: operations["update_referral_code"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user_subscription": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** User Subscription */
        get: operations["user_subscription"];
        put?: never;
        /** Free Subscription */
        post: operations["free_subscription"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/ping": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Ping */
        get: operations["ping"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/checkers_status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Checkers Status */
        get: operations["checkers_status"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/inbox/backfill_status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get Inbox Backfill Status */
        get: operations["get_inbox_backfill_status"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/integrations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Integrations Get */
        get: operations["integrations_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/custom_instructions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get User Custom Instructions */
        get: operations["get_user_custom_instructions"];
        /** Update User Custom Instructions */
        put: operations["update_user_custom_instructions"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/send_as": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get Send As */
        get: operations["get_send_as"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/writing_example": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Writing Example
         * @description Get the user's writing example
         */
        get: operations["get_writing_example"];
        /**
         * Update Writing Example
         * @description Update the user's writing example
         */
        put: operations["update_writing_example"];
        post?: never;
        /**
         * Delete Writing Example
         * @description Delete the user's writing example
         */
        delete: operations["delete_writing_example"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/metadata": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get Metadata */
        get: operations["get_metadata"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/calendar/events/{event_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get Calendar Event */
        get: operations["get_calendar_event"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/messages": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get All Messages */
        get: operations["get_all_messages"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/gmail-email/{email_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get Gmail Email */
        get: operations["get_gmail_email"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get All Threads */
        get: operations["get_all_threads"];
        put?: never;
        /** Thread Create */
        post: operations["thread_create"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/contacts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get All Contacts */
        get: operations["get_all_contacts"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/sync": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Sync Stream Endpoint
         * @description Streams all sync actions and updates to the frontend.
         */
        get: operations["sync_stream_endpoint"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/read_statuses": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get Read Statuses */
        get: operations["get_read_statuses"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/r/{rid}.gif": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get Read Pixel */
        get: operations["get_read_pixel"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/data_sync_validation": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Data Sync Validation
         * @description Validate data synchronization between client and server by comparing counts of threads.
         *     Compares client-side and server-side counts for threads before a given timestamp.
         *     The timestamp is expected to be UTC-aware, and will be converted if not.
         *
         *     If thread_ids is provided, it will also check for discrepancies between client and server thread IDs.
         */
        post: operations["data_sync_validation"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/files/download": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Download File Get */
        get: operations["download_file_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/files": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** File Delete */
        delete: operations["file_delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/files/metadata": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** File Metadata Get */
        get: operations["file_metadata_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** File Metadata Update */
        patch: operations["file_metadata_update"];
        trace?: never;
    };
    "/api/files/upload-url": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Thread Upload Url Post */
        post: operations["thread_upload_url_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/gmail/labels": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Labels
         * @description Get all Gmail labels for the current user.
         */
        get: operations["get_labels"];
        put?: never;
        /**
         * Create Label
         * @description Create a new Gmail label.
         */
        post: operations["create_label"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/gmail/labels/{label_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Label
         * @description Get a specific Gmail label by ID.
         */
        get: operations["get_label"];
        put?: never;
        post?: never;
        /**
         * Delete Label
         * @description Delete a Gmail label.
         */
        delete: operations["delete_label"];
        options?: never;
        head?: never;
        /**
         * Update Label
         * @description Update a Gmail label.
         */
        patch: operations["update_label"];
        trace?: never;
    };
    "/api/gmail/labels/toggle-message-visibility": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Toggle Zeta Labels Visibility Endpoint
         * @description Toggle visibility of all ZETA labels in the message list.
         *
         *     Args:
         *         visibility_data: The visibility toggle data
         */
        post: operations["toggle_zeta_labels_visibility_endpoint"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/gmail-webhook": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Gmail Webhook */
        post: operations["gmail_webhook"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/stripe/checkout_session": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Create Checkout Session */
        post: operations["create_checkout_session"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/stripe/buy_subscription": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Buy Subscription */
        post: operations["buy_subscription"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/stripe/billing_portal_session": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Create Billing Portal Session */
        post: operations["create_billing_portal_session"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/stripe/webhook": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Stripe Webhook */
        post: operations["stripe_webhook"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/save_credentials": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Save Credentials
         * @description Saves credentials and also finishes credential request based on credential_request ID
         */
        post: operations["save_credentials"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/credentials": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get Credentials */
        get: operations["get_credentials"];
        put?: never;
        /** Add Credential */
        post: operations["add_credential"];
        /** Delete Credential */
        delete: operations["delete_credential"];
        options?: never;
        head?: never;
        /** Update Credential */
        patch: operations["update_credential"];
        trace?: never;
    };
    "/api/auth/jwt_token": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get Jwt Token */
        get: operations["get_jwt_token"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/auth/refresh_token": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get Jwt Token Refresh */
        get: operations["get_jwt_token_refresh"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/users/{user_id_or_email}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** Admin Delete User */
        delete: operations["admin_delete_user"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/clear-inbox": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Admin Clear Inbox
         * @description Deletes the users emails and then reimports them again. increments the global data version.
         */
        post: operations["admin_clear_inbox"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/envs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Admin Get Env Py */
        get: operations["admin_get_env_py"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Search Threads
         * @description Search and filter threads for the authorized user. This endpoint supports both semantic search (when query is provided)
         *     and filtering by various criteria.
         *
         *     ## Arguments
         *     * `thread_type` (Literal["all", "inbox", "chat"]): Filter threads by type. Defaults to "all".
         *     * `thread_mode` (Literal["agent", "all"]): Filter threads by AI agent presence. "all" for all threads, "agent" for threads with an AI agent only.
         *     * `query` (str | None): Optional semantic search query string. Can only be used to search for emails in inbox threads.
         *     * `offset` (int): The number of threads to skip for pagination. Defaults to 0.
         *     * `limit` (int): The maximum number of threads to return. Defaults to 50, max 100.
         *     * `labels` (str): Optional comma-separated string of Gmail labels to filter threads by. By adding labels with a prefix of "NON-" you can exclude threads with those labels. Works as an OR filter.
         *     * `inbox_label` (Literal["all", "inbox", "non-inbox"]): If "inbox", returns ONLY threads that have INBOX label. If "non-inbox", returns ONLY threads that DON'T have INBOX label.
         *
         *     ## Returns
         *     * `list[str]`: A list of thread_ids matching the search criteria.
         */
        get: operations["search_threads"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/{thread_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/gmail/{gmail_thread_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/init-personality-analysis-thread": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Post Init Personality Analysis Thread */
        post: operations["post_init_personality_analysis_thread"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/create_brief_thread": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Create Brief Thread Route */
        post: operations["create_brief_thread_route"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/{thread_id}/email_reply": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Email Reply
         * @description Triggers a new reply for a given thread.
         */
        post: operations["email_reply"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/{thread_id}/forward_email": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Forward Email */
        post: operations["forward_email"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/{thread_id}/messages": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Thread Message Create */
        post: operations["thread_message_create"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/{thread_id}/read": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Thread Toggle Read
         * @description Toggle the read status of a thread.
         *
         *     Args:
         *         thread_id: The ID of the thread to toggle
         *         user_and_thread: The authorized user and thread
         *         is_read: Whether to mark the thread as read (True) or unread (False)
         */
        post: operations["thread_toggle_read"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/{thread_id}/retry_execute_reply": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Retry Execute Reply
         * @description Retries the execution of a reply for a given thread.
         */
        post: operations["retry_execute_reply"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/{thread_id}/edit_drafts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Edit Drafts
         * @description Sends a list of edits to DraftMessages
         */
        post: operations["edit_drafts"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/{thread_id}/submit_drafts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Submit Drafts
         * @description Submits all drafts specified by their IDs for a given thread. The model ids are the ids of the DraftMessages.
         */
        post: operations["submit_drafts"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/{thread_id}/schedule_send": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** Schedule Send */
        delete: operations["schedule_send"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/{thread_id}/change_labels": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Change Labels
         * @description Adds specified labels to a thread.
         *
         *     ## Arguments
         *     * `thread_id` (str): The ID of the thread to add labels to.
         *     * `request_model` (ThreadLabelsRequest): The request model containing the labels to add.
         *
         *     ## Returns
         *     * 204 No Content on success.
         */
        post: operations["change_labels"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/{thread_id}/snooze": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Thread Snooze
         * @description Snoozes a thread until the specified time by adding a SNOOZE label and setting the snooze_until attribute.
         *     If snooze_until is None, the thread will be unsnoozed by removing the SNOOZE label and clearing the snooze_until attribute.
         *
         *     ## Arguments
         *     * `thread_id` (str): The ID of the thread to snooze or unsnooze.
         *     * `request_model` (ThreadSnoozeReq  uest): The request model containing the snooze_until datetime or None to unsnooze.
         *
         *     ## Returns
         *     * 204 No Content on success.
         */
        post: operations["thread_snooze"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/{thread_id}/apply_draft_suggestion": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Apply Draft Suggestion
         * @description Applies a draft change suggestion and triggers a new reply. The user should be blocked from submitting another prompt for a few seconds
         */
        post: operations["apply_draft_suggestion"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/{thread_id}/apply_custom_draft_edit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Apply Custom Draft Edit
         * @description Requests a custom edit based on a prompt and triggers a new reply that creates the draft update.
         */
        post: operations["apply_custom_draft_edit"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/{thread_id}/ask_for_context": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Ask For Context */
        post: operations["ask_for_context"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/{thread_id}/person_essay": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Person Essay
         * @description Creates a detailed essay about a person based on email history and web search.
         */
        post: operations["person_essay"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/bulk": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Get Threads By Ids
         * @description Get threads by their IDs. Only returns threads that the user has access to.
         *     Threads are returned in the same order as the input thread_ids.
         */
        post: operations["get_threads_by_ids"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/threads/{thread_id}/cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Cancel Generation
         * @description Cancels an ongoing generation for a thread.
         *
         *     ## Arguments
         *     * `thread_id` (str): The ID of the thread to cancel generation for.
         *
         *     ## Returns
         *     * 204 No Content on success.
         */
        post: operations["cancel_generation"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/filter_views": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get All Filter Views
         * @description Get all thread views for a user since a certain timestamp
         */
        get: operations["get_all_filter_views"];
        put?: never;
        /**
         * Create Filter View
         * @description Create a new thread view
         */
        post: operations["create_filter_view"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/filter_views/{view_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Delete Filter View
         * @description Delete a thread view
         */
        delete: operations["delete_filter_view"];
        options?: never;
        head?: never;
        /**
         * Update Filter View
         * @description Update an existing thread view
         */
        patch: operations["update_filter_view"];
        trace?: never;
    };
    "/api/filter_views/reset": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reset Filter Views
         * @description Reset thread views to default state
         */
        post: operations["reset_filter_views"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/ai-filters": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Ai Filters
         * @description Get all AI filters for a user.
         */
        get: operations["list_ai_filters"];
        put?: never;
        /**
         * Create Ai Filter
         * @description Create a new AI filter.
         */
        post: operations["create_ai_filter"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/ai-filters/{filter_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Delete Ai Filter
         * @description Delete an AI filter.
         */
        delete: operations["delete_ai_filter"];
        options?: never;
        head?: never;
        /**
         * Update Ai Filter
         * @description Update an existing AI filter.
         */
        patch: operations["update_ai_filter"];
        trace?: never;
    };
    "/api/ai-filters/reset": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reset Ai Filters
         * @description Reset AI filters for the current user.
         *
         *     This endpoint:
         *     1. Deletes all Zeta labels for the user
         *     2. Deletes all system AI filters for the user
         *     3. Creates default AI filters for the user
         */
        post: operations["reset_ai_filters"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/{service_name}/connect": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Integration Connect */
        get: operations["integration_connect"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/{service_name}/callback": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Integration Callback */
        get: operations["integration_callback"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/integration/{service_name}/disconnect": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Disconnect Integration */
        get: operations["disconnect_integration"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/messages/bulk": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Get Messages By Ids
         * @description Get messages by their IDs. Only returns messages from threads that the user has access to.
         *     Messages are filtered through client_filter_message and sorted by timestamp.
         */
        post: operations["get_messages_by_ids"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/affiliate/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get Affiliate Stats */
        get: operations["get_affiliate_stats"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/affiliate/cumulative_profit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get Cumulative Profit */
        get: operations["get_cumulative_profit"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/affiliate/total_signups": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get Total Signups */
        get: operations["get_total_signups"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/affiliate/commission_history": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get Commission History */
        get: operations["get_commission_history"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/affiliate/user_info": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get Affiliate User Info */
        get: operations["get_affiliate_user_info"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/affiliate/signin": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Post Login Affiliate User */
        post: operations["post_login_affiliate_user"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/affiliate/send_magic_link": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Post Send Magick Link */
        post: operations["post_send_magick_link"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/affiliate/verify_magic_link": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Post Verify Magic Link */
        post: operations["post_verify_magic_link"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/slack/notify": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send Slack Message
         * @description Send a message to a Slack channel using the configured Slack bot.
         *
         *     Args:
         *         request: The SlackNotificationRequest containing the message and optional parameters
         *         user: The authenticated user
         *
         *     Returns:
         *         A dictionary with a success message
         */
        post: operations["send_slack_message"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /**
         * AIFilter
         * @description Data model for an AI filter.
         */
        AIFilter: {
            /** Id */
            id: string;
            /** User Id */
            user_id: string;
            /** Prompt */
            prompt: string;
            /** Action Add Labels */
            action_add_labels: string[];
            /** Action Remove Labels */
            action_remove_labels: string[];
            /** Action Mark Done */
            action_mark_done: boolean;
            /** Enabled */
            enabled: boolean;
            /** Type */
            type: string;
            /**
             * Created At
             * Format: date-time
             */
            created_at: string;
            /**
             * Updated At
             * Format: date-time
             */
            updated_at: string;
        };
        /**
         * AIFilterCreate
         * @description Data model for creating a new AI filter.
         */
        AIFilterCreate: {
            /** Prompt */
            prompt: string;
            /** Action Add Labels */
            action_add_labels: string[];
            /** Action Remove Labels */
            action_remove_labels: string[];
            /**
             * Action Mark Done
             * @default false
             */
            action_mark_done: boolean;
            /**
             * Type
             * @default user
             */
            type: string;
        };
        /**
         * AIFilterUpdate
         * @description Data model for updating an existing AI filter.
         */
        AIFilterUpdate: {
            /** Prompt */
            prompt: string | null;
            /** Action Add Labels */
            action_add_labels: string[] | null;
            /** Action Remove Labels */
            action_remove_labels: string[] | null;
            /** Action Mark Done */
            action_mark_done: boolean | null;
            /** Enabled */
            enabled: boolean | null;
            /** Type */
            type: string | null;
        };
        /** APIAddCredentialInput */
        APIAddCredentialInput: {
            /** Domain */
            domain: string;
            /** Username */
            username: string;
            /** Password */
            password: string;
        };
        /** APIAddCredentialOutput */
        APIAddCredentialOutput: {
            /** Domain */
            domain: string;
            /** Username */
            username: string;
        };
        /** APIAdminClearInboxRequest */
        APIAdminClearInboxRequest: {
            /** Email */
            email: string;
        };
        /** APIDeleteCredentialInput */
        APIDeleteCredentialInput: {
            /** Domain */
            domain: string;
            /** Username */
            username: string;
        };
        /** APIDeleteCredentialOutput */
        APIDeleteCredentialOutput: {
            /** Domain */
            domain: string;
            /** Username */
            username: string;
        };
        /** APIEmailForwardInput */
        APIEmailForwardInput: {
            /** Message Id */
            message_id: string;
        };
        /** APIEmailReplyInput */
        APIEmailReplyInput: {
            /** Message Id */
            message_id: string;
        };
        /**
         * APIGetCredentialsOutput
         * @description List of domains each with multiple usernames
         */
        APIGetCredentialsOutput: {
            /** Domains */
            domains: components["schemas"]["DomainCredentials"][];
        };
        /** APIGetJWTTokenResponse */
        APIGetJWTTokenResponse: {
            /** Jwt */
            jwt: string;
        };
        /** APIMeInput */
        APIMeInput: {
            /** Preferences */
            preferences: {
                [key: string]: unknown;
            };
            /** From Referral Code */
            from_referral_code: string | null;
        };
        /** APIMeResponse */
        APIMeResponse: {
            /** Id */
            id: string;
            /** Email */
            email: string | null;
            /** Display Name */
            display_name: string | null;
            /** From Referral Code */
            from_referral_code: string | null;
            /** Preferences */
            preferences: {
                [key: string]: unknown;
            };
            /** Feature Flags */
            feature_flags: {
                [key: string]: unknown;
            };
            /** Reflink */
            reflink: string | null;
            /** Timezone */
            timezone: string | null;
            /**
             * Send As
             * @default []
             */
            send_as: components["schemas"]["APISendAs"][];
            /** Updated */
            updated: string | null;
            /**
             * Created
             * Format: date-time
             */
            created: string;
        };
        /** APIRequestCredentialInputModel */
        APIRequestCredentialInputModel: {
            /** Request Id */
            request_id: string;
            /** Username */
            username: string;
            /** Password */
            password: string;
            /**
             * Needs Registration
             * @default false
             */
            needs_registration: boolean;
            /** Thread Id */
            thread_id: string | null;
        };
        /** APIRequestCredentialsModel */
        APIRequestCredentialsModel: {
            /** Id */
            id: string;
            /** User Id */
            user_id: string;
            /** Step Number */
            step_number: number;
            /** Is Finished */
            is_finished: boolean;
            /** Domain */
            domain: string;
            /**
             * Created
             * Format: date-time
             */
            created: string;
            /** Updated */
            updated: string | null;
        };
        /** APISendAs */
        APISendAs: {
            /** Send As Email */
            send_as_email: string;
            /** Reply To Address */
            reply_to_address: string | null;
            /** Display Name */
            display_name: string;
            /** Is Primary */
            is_primary: boolean;
            /** Is Default */
            is_default: boolean;
            /** Signature */
            signature: string | null;
        };
        /** APISubscriptionCheckoutSessionInput */
        APISubscriptionCheckoutSessionInput: {
            product: components["schemas"]["SubscriptionProductId"];
            /** Success Url */
            success_url: string;
            /** Cancel Url */
            cancel_url: string;
        };
        /** APISubscriptionSessionUrlResponse */
        APISubscriptionSessionUrlResponse: {
            /** Destination */
            destination: string;
        };
        /** APIUpdateCredentialInput */
        APIUpdateCredentialInput: {
            /** Domain */
            domain: string;
            /** Previous Username */
            previous_username: string | null;
            /** Username */
            username: string;
            /** Password */
            password: string;
        };
        /** APIUpdateCredentialOutput */
        APIUpdateCredentialOutput: {
            /** Domain */
            domain: string;
            /** Username */
            username: string;
        };
        /** APIUserSubscriptionResponse */
        APIUserSubscriptionResponse: {
            /** Name */
            name: string;
            /** Messages Used */
            messages_used: number;
            /** Messages Limit */
            messages_limit: number | null;
            /** Is Messages Limit Exceeded */
            is_messages_limit_exceeded: boolean;
            /** Drafts Used */
            drafts_used: number;
            /** Drafts Limit */
            drafts_limit: number | null;
            /** Is Drafts Limit Exceeded */
            is_drafts_limit_exceeded: boolean;
            /** Period Start */
            period_start: string | null;
            /** Period End */
            period_end: string | null;
            /** Is Existing Customer */
            is_existing_customer: boolean;
            /** Cancel At */
            cancel_at: string | null;
        };
        /** AffiliateInfo */
        AffiliateInfo: {
            /** Name */
            name: string;
            /** Discount Code */
            discount_code: string;
        };
        /** AffiliateStats */
        AffiliateStats: {
            /** Active Referrals */
            active_referrals: number;
            /** Total Earnings */
            total_earnings: number;
            /** Pending Payout */
            pending_payout: number;
        };
        /** AffiliateUserInfoResponse */
        AffiliateUserInfoResponse: {
            affiliate_info: components["schemas"]["AffiliateInfo"];
        };
        /** ApplyCustomDraftEditRequest */
        ApplyCustomDraftEditRequest: {
            /** Draft Id */
            draft_id: string;
            /** Prompt */
            prompt: string;
            /**
             * Field
             * @description The field to edit, such as 'body' or 'subject'
             */
            field: string;
            /** Range Start */
            range_start: number | null;
            /** Range End */
            range_end: number | null;
        };
        /** ApplyDraftSuggestionRequest */
        ApplyDraftSuggestionRequest: {
            /** Suggestion Id */
            suggestion_id: string;
        };
        /**
         * ApprovalRequestMessage
         * @description The web agent requires an approval from the user for a certain plan part.
         */
        ApprovalRequestMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: ApprovalRequestMessageRole;
            /** Request Id */
            request_id: string;
            /** Tool Id */
            tool_id: string;
            /** Approval Message */
            approval_message: string;
        };
        /** ApprovalSuccessMessage */
        ApprovalSuccessMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: ApprovalSuccessMessageRole;
            /** Request Id */
            request_id: string;
        };
        /** AskForContextRequest */
        AskForContextRequest: {
            /** Message Id */
            message_id: string;
            /** Optimistic Prompt */
            optimistic_prompt: string;
        };
        /** AssistantCreatedMessage */
        AssistantCreatedMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: AssistantCreatedMessageRole;
        };
        /**
         * AssistantMessage
         * @description Aggregation of the content of all AssistantTokenMessage with the same full_message_id
         */
        AssistantMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: AssistantMessageRole;
            /** Content */
            content: string;
            /**
             * Intermediate
             * @default false
             */
            intermediate: boolean;
            /** Tool Call Group Id */
            tool_call_group_id: string | null;
            /** Real Text */
            real_text: string | null;
        };
        /**
         * AssistantTokenMessage
         * @description A single token of the standard chat message of the manager
         */
        AssistantTokenMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: AssistantTokenMessageRole;
            /** Full Message Id */
            full_message_id: string;
            /** Content */
            content: string;
            /** Token Idx */
            token_idx: number;
        };
        /** Attendee */
        Attendee: {
            /**
             * Email
             * @description The attendee's email address.
             */
            email: string;
            /**
             * Displayname
             * @description The attendee's name, if available.
             */
            displayName: string | null;
            /**
             * Responsestatus
             * @description The attendee's response status (e.g., 'needsAction', 'declined', 'tentative', 'accepted')
             */
            responseStatus: string | null;
        };
        /**
         * AutosuggestsMessage
         * @description After an AssistantMessage, we provide a few suggested user responses. Can be shown as buttons.
         */
        AutosuggestsMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: AutosuggestsMessageRole;
            /** Autosuggests */
            autosuggests: string[];
            /** Response To Id */
            response_to_id: string;
        };
        /**
         * Bash
         * @description Run commands in a bash shell
         *     * When invoking this tool, the contents of the "command" parameter does NOT need to be XML-escaped.
         *     * You have access to a mirror of common linux and python packages via apt and pip.
         *     * State is persistent across command calls and discussions with the user.
         *     * To inspect a particular line range of a file, e.g. lines 10-25, try 'sed -n 10,25p /path/to/the/file'.
         *     * Please avoid commands that may produce a very large amount of output.
         *     * Please run long lived commands in the background, e.g. 'sleep 10 &' or start a server in the background.
         *     * The machine does not have python libraries pre-installed.
         *     * For example if you want to run a python script try to think ahead and install libraries and check outputs if your scripts create files: `cd /home/scrapybara/jace && pip install numpy matplotlib && python interest_simulation.py && ls`
         */
        Bash: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: BashRole;
            /**
             * Command
             * @description The bash command to run. Required unless the tool is being restarted.
             */
            command: string | null;
            /**
             * Restart
             * @description Specifying true will restart this tool. Otherwise, leave this unspecified.
             */
            restart: boolean | null;
        };
        /** BashResponse */
        BashResponse: {
            /** Content */
            content: string;
        };
        /**
         * Calendar
         * @description Represents a calendar for the user.
         */
        Calendar: {
            /**
             * Id
             * @description The ID of the calendar.
             */
            id: string;
            /**
             * Summary
             * @description The summary of the calendar.
             */
            summary: string;
            /**
             * Access Role
             * @description The access role of the calendar.
             */
            access_role: string;
            /**
             * Primary
             * @description Whether this is the primary calendar.
             */
            primary: boolean;
            /**
             * Time Zone
             * @description The time zone of the calendar.
             */
            time_zone: string;
        };
        /** CalendarInfo */
        CalendarInfo: {
            /**
             * Type
             * @default calendar
             * @constant
             */
            type: "calendar";
        };
        /** CancelScheduledTaskResponse */
        CancelScheduledTaskResponse: {
            /**
             * Response Role
             * @default cancel_scheduled_task
             * @constant
             */
            response_role: "cancel_scheduled_task";
            /** Status */
            status: string;
        };
        /**
         * CancelTool
         * @description Cancel a tool that is currently running. Provide the tool_id of the tool you want to cancel. Only `recurring_activation` and `wait` tools can be cancelled.
         */
        CancelTool: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: CancelToolRole;
            /** Reasoning */
            reasoning: string;
            /**
             * Tool Id
             * @description The tool_id of the tool you want to cancel. Usually starts with 'call_'
             */
            tool_id: string;
        };
        /** CancelToolResponse */
        CancelToolResponse: {
            /**
             * Response Role
             * @default cancel_tool
             * @constant
             */
            response_role: "cancel_tool";
            /** Status */
            status: string;
        };
        /**
         * CodeInterpreter
         * @description Tell an AI to modify or analyze real files and run code for plots/calculations or to create new files.
         */
        CodeInterpreter: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: CodeInterpreterRole;
            /**
             * Instructions
             * @description Natural language query, e.g. 'plot a graph of sin(x)'. (No code here)
             */
            instructions: string;
        };
        /** CodeInterpreterResponse */
        CodeInterpreterResponse: {
            /**
             * Response Role
             * @default code_interpreter
             * @constant
             */
            response_role: "code_interpreter";
            /** Response */
            response: string | null;
            /** Unified Uris */
            unified_uris: components["schemas"]["UnifiedUri"][] | null;
        };
        /** CommissionEntry */
        CommissionEntry: {
            /** Date */
            date: string;
            /** Amount */
            amount: number;
            /** Status */
            status: string;
        };
        /** CommissionHistoryResponse */
        CommissionHistoryResponse: {
            /** Commission History */
            commission_history: components["schemas"]["CommissionEntry"][];
        };
        /** Contact */
        Contact: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: ContactType;
            /** Id */
            id: string;
            /** Name */
            name: string | null;
            /** Email */
            email: string;
            /** Short Bio */
            short_bio: string | null;
            /** Long Bio */
            long_bio: string | null;
            /** One Line Role */
            one_line_role: string | null;
            /**
             * Profile Links
             * @default []
             */
            profile_links: string[];
            /**
             * Updated At
             * Format: date-time
             */
            updated_at: string;
        };
        /**
         * CreateAgentFile
         * @description Creates a new agent file with the given path and content.
         */
        CreateAgentFile: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: CreateAgentFileRole;
            /**
             * Path
             * @description The path of the file to create, including filename. If the folder structure does not exist yet, it will be created automatically.
             */
            path: string;
            /**
             * Content
             * @description The content of the file to create. The formatting should be markdown.
             */
            content: string;
        };
        /** CreateAgentFileResponse */
        CreateAgentFileResponse: {
            /**
             * Response Role
             * @default create_agent_file
             * @constant
             */
            response_role: "create_agent_file";
            /** Status */
            status: string;
            /** File Path */
            file_path: string;
        };
        /** CreatePlanResponse */
        CreatePlanResponse: {
            /**
             * Response Role
             * @default create_plan
             * @constant
             */
            response_role: "create_plan";
            /** Status */
            status: string;
        };
        /**
         * CredentialRequestMessage
         * @description The web agent requires a credential for a specific domain from the user.
         */
        CredentialRequestMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: CredentialRequestMessageRole;
            /** Request Id */
            request_id: string;
            /** Tool Id */
            tool_id: string;
            /** Domain Url */
            domain_url: string;
        };
        /** CredentialSuccessMessage */
        CredentialSuccessMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: CredentialSuccessMessageRole;
            /** Request Id */
            request_id: string;
        };
        /** CumulativeProfitResponse */
        CumulativeProfitResponse: {
            /** Cumulative Profit */
            cumulative_profit: components["schemas"]["ProfitDataPoint"][];
        };
        /** CustomInstructions */
        CustomInstructions: {
            /** Instructions */
            instructions: string | null;
        };
        /** CustomInstructionsResponse */
        CustomInstructionsResponse: {
            /** Instructions */
            instructions: string | null;
        };
        /**
         * DataSyncValidationInput
         * @description Request model for validating data synchronization between client and server by comparing message and thread counts
         */
        DataSyncValidationInput: {
            /**
             * Timestamp
             * Format: date-time
             * @description UTC timestamp to check counts before
             */
            timestamp: string;
            /** Threads Count */
            threads_count: number;
            /** Thread Ids */
            thread_ids: string[] | null;
        };
        /**
         * DataSyncValidationResponse
         * @description Response model containing information about data sync discrepancies
         */
        DataSyncValidationResponse: {
            /**
             * Status
             * @default success
             * @enum {string}
             */
            status: DataSyncValidationResponseStatus;
            /**
             * Threads Only On Client
             * @description Thread IDs that exist on client but not on server
             */
            threads_only_on_client: string[];
            /**
             * Threads Only On Server
             * @description Thread IDs that exist on server but not on client
             */
            threads_only_on_server: string[];
            /**
             * Messages In Missing Threads
             * @description Message IDs that belong to threads that exist on server but not on client
             */
            messages_in_missing_threads: string[];
            /**
             * Thread Count Mismatch
             * @default false
             */
            thread_count_mismatch: boolean;
            /** Server Thread Count */
            server_thread_count: number;
            /** Client Thread Count */
            client_thread_count: number;
        };
        /**
         * DeleteAgentFile
         * @description Deletes an existing agent file.
         */
        DeleteAgentFile: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: DeleteAgentFileRole;
            /**
             * Path
             * @description The path of the file to delete, including filename
             */
            path: string;
        };
        /** DeleteAgentFileResponse */
        DeleteAgentFileResponse: {
            /**
             * Response Role
             * @default delete_agent_file
             * @constant
             */
            response_role: "delete_agent_file";
            /** Status */
            status: string;
        };
        /** DeleteCalendarInfo */
        DeleteCalendarInfo: {
            /**
             * Type
             * @default delete_calendar
             * @constant
             */
            type: "delete_calendar";
            calendar_event: components["schemas"]["GoogleCalendarEvent"];
        };
        /**
         * DeleteDraft
         * @description Deletes a draft
         */
        DeleteDraft: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: DeleteDraftRole;
            /**
             * Draft Reference Id
             * @description The draft_reference_id of the draft to be deleted.
             */
            draft_reference_id: string;
        };
        /** DeleteDraftResponse */
        DeleteDraftResponse: {
            /**
             * Response Role
             * @default delete_draft
             * @constant
             */
            response_role: "delete_draft";
            /** Status */
            status: string;
        };
        /** DeleteFileDeleteRequest */
        DeleteFileDeleteRequest: {
            /** Unified Uri Str */
            unified_uri_str: string;
        };
        /** DeleteFileDeleteResponse */
        DeleteFileDeleteResponse: {
            /**
             * Status
             * @enum {string}
             */
            status: DeleteFileDeleteResponseStatus;
            /** Error Message */
            error_message: string | null;
        };
        /**
         * DocumentSpan
         * @description Represents a relevant section of an email or document. To keep things short, use the search_index if possible, otherwise use the file_uri.
         *     Check your <submit_instructions> for information on when to use the summary field.
         */
        DocumentSpan: {
            /**
             * Search Index
             * @description search_index of the email/document you want to submit. (a search_index maps and is a short form replacement for the full file_uri) If no search_index is available, use the file_uri.
             */
            search_index: string | null;
            /**
             * File Uri
             * @description Optional, only relevant if the email does not have an search_index. UnifiedUri of the email/document
             */
            file_uri: string | null;
            /**
             * Summary
             * @description Optional, only allowed for very long emails (>50 lines) or very long documents (>100 lines)! Strictly forbidden for normal length emails or documents. If used it should contain a short summary of the email or document. Should be mostly ignored and only be used for very very long things.
             */
            summary: string | null;
            /**
             * Start Idx
             * @description Optional start index int (line-based or chunk-based) for the snippet. or timestamp float for slack messages Leave empty if you want the entire document or already set a `description`.
             */
            start_idx: number | null;
            /**
             * End Idx
             * @description Optional end index int (exclusive) for the snippet. or timestamp float for slack messages Leave empty if you want the entire document or already set a `description`.
             */
            end_idx: number | null;
        };
        /** DomainCredentials */
        DomainCredentials: {
            /** Domain */
            domain: string;
            /** Usernames */
            usernames: string[];
        };
        /** DownloadFileGetResponse */
        DownloadFileGetResponse: {
            /** Url */
            url: string;
        };
        /** DraftChangeAutoSuggestion */
        DraftChangeAutoSuggestion: {
            /** Id */
            id: string;
            /** Text */
            text: string;
        };
        /** DraftChangeSuggestionMessage */
        DraftChangeSuggestionMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: DraftChangeSuggestionMessageRole;
            /**
             * Autosuggests
             * @description array type is deprecated
             */
            autosuggests: components["schemas"]["DraftChangeAutoSuggestion"][] | string[];
            /**
             * Response To Id
             * @description References the id of a DraftMessage that this suggestion is responding to
             */
            response_to_id: string;
            /**
             * Draft Id
             * @description The id of the draft that this suggestion is responding to
             */
            draft_id: string;
        };
        /** DraftEmailBodyMessage */
        DraftEmailBodyMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: DraftEmailBodyMessageRole;
            /** Draft Id */
            draft_id: string;
            /** Final Body Markdown */
            final_body_markdown: string;
        };
        /**
         * DraftGoogleCalendarDeleteEvent
         * @description Create a draft to delete an event from the user's calendar.
         *     This creates a draft that the user must approve before the event is actually deleted.
         */
        DraftGoogleCalendarDeleteEvent: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: DraftGoogleCalendarDeleteEventRole;
            /**
             * Calendar Id
             * @description The ID of the calendar.
             */
            calendar_id: string;
            /**
             * Event Id
             * @description The ID of the event to delete.
             */
            event_id: string;
        };
        /** DraftGoogleCalendarDeleteEventResponse */
        DraftGoogleCalendarDeleteEventResponse: {
            /**
             * Response Role
             * @default draft_google_calendar_delete_event
             * @constant
             */
            response_role: "draft_google_calendar_delete_event";
            /** Status */
            status: string;
        };
        /**
         * DraftGoogleCalendarUpsertEvent
         * @description Proactively create or update a draft for a Google Calendar event whenever scheduling, events, or time-related topics are mentioned or implied.
         *     Be highly liberal with drafting events, as there is no risk—users can always ignore or decline drafts.
         *
         *     Scenarios:
         *       1) New event: omit gcal_event_id
         *       2) Update existing event or draft: provide gcal_event_id
         *
         *     Will use the users timezone automatically. For different timezones, use the time_zone field.
         *     When updating, re-provide all fields with final values.
         */
        DraftGoogleCalendarUpsertEvent: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: DraftGoogleCalendarUpsertEventRole;
            /**
             * Gcal Event Id
             * @description Existing event ID. Omit unless you're updating an event or a draft tied to an event.
             */
            gcal_event_id: string | null;
            /**
             * Calendar Id
             * @description Uses primary if omitted.
             */
            calendar_id: string | null;
            /**
             * Summary
             * @description Event title.
             */
            summary: string;
            /**
             * Description
             * @description Event description or notes.
             */
            description: string | null;
            /**
             * Location
             * @description Event location.
             */
            location: string | null;
            /**
             * Time Zone
             * @description Event timezone. If not provided, the user's timezone will be used.
             */
            time_zone: string | null;
            /**
             * Start Datetime
             * @description Start date/time in ISO 8601.
             */
            start_datetime: string;
            /**
             * End Datetime
             * @description End date/time in ISO 8601.
             */
            end_datetime: string;
            /**
             * Rsvp Response
             * @description Set the user's RSVP status.
             */
            rsvp_response: DraftGoogleCalendarUpsertEventRsvp_response | null;
            /**
             * Attendees Emails
             * @description Full list of attendee emails. Don't forget to add the user's email.
             */
            attendees_emails: string[] | null;
            /**
             * Needs Google Meets
             * @description If true, creates a Google Meet link.
             */
            needs_google_meets: boolean | null;
        };
        /** DraftGoogleCalendarUpsertEventInfo */
        DraftGoogleCalendarUpsertEventInfo: {
            /**
             * Type
             * @default draft_google_calendar_upsert_event
             * @constant
             */
            type: "draft_google_calendar_upsert_event";
            /** Overlapping Events */
            overlapping_events: components["schemas"]["GoogleCalendarEvent"][];
            /** Is Existing Event */
            is_existing_event: boolean;
            /** Draft Id */
            draft_id: string;
        };
        /** DraftGoogleCalendarUpsertEventResponse */
        DraftGoogleCalendarUpsertEventResponse: {
            /**
             * Response Role
             * @default draft_google_calendar_upsert_event
             * @constant
             */
            response_role: "draft_google_calendar_upsert_event";
            /** Message */
            message: string;
            /** @description The event after insertion or update. */
            event: components["schemas"]["GoogleCalendarEvent"] | null;
            /**
             * Overlapping Events
             * @description List of overlapping events.
             */
            overlapping_events: components["schemas"]["GoogleCalendarEvent"][] | null;
        };
        /**
         * DraftMessage
         * @description follows a ToolCallMessage in case a tool creates a Draft. Provides a short reference id for the draft.
         */
        DraftMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: DraftMessageRole;
            /** Tool Id */
            tool_id: string;
            /** Tool Call Group Id */
            tool_call_group_id: string;
            /** Tool */
            tool: components["schemas"]["DraftSendEmail"] | components["schemas"]["DraftGoogleCalendarUpsertEvent"] | components["schemas"]["DraftGoogleCalendarDeleteEvent"] | components["schemas"]["DraftSlackSendMessage"] | components["schemas"]["GoogleCalendarUpsertEvent"];
            /** Draft Id */
            draft_id: string;
            status: components["schemas"]["DraftStatus"] | null;
            /** Info */
            info: components["schemas"]["EmailInfo"] | components["schemas"]["CalendarInfo"] | components["schemas"]["SlackInfo"] | components["schemas"]["DeleteCalendarInfo"] | null;
        };
        /** DraftNotificationMessage */
        DraftNotificationMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: DraftNotificationMessageRole;
            /** Draft Id */
            draft_id: string;
            /** Draft Notification */
            draft_notification: string;
        };
        /**
         * DraftSendEmail
         * @description Creates or updates an email draft. Precisely match user's writing style and way of writing emails.
         */
        DraftSendEmail: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: DraftSendEmailRole;
            /** To */
            to: string[];
            /** Cc */
            cc: string[];
            /** Bcc */
            bcc: string[];
            /**
             * Subject
             * @description Subject line of the email.
             *     - Always set for new emails.
             *     - Never set for normal replies or forwards (95% of cases).
             *     - Setting this for a reply or forward will send this email in a new unrelated conversation thread (only do this if the email is unrelated to the conversation or if the user asks you to).
             */
            subject: string | null;
            /**
             * Body
             * @description Body of the email draft. Precisely match the user's exact writing style, tone, and brevity. Never introduce information, requests, or details the user hasn't explicitly demonstrated in similar past emails. Avoid unnecessary elaboration, overly detailed feedback, or assumptions unless clearly consistent with historical user behavior. Follow additional rules about signature or closing remarks if provided.
             * @default
             */
            body: string;
            /**
             * File Uris Attachments
             * @description URIs of files to attach to the email. If you reply to an email, do not include the files that were attached to the original email. Make sure to only add URIs you know exist.
             */
            file_uris_attachments: string[];
            /**
             * Reply To Id
             * @description An ID of the email you are replying to. Most of the time you are replying to an email, in which case you MUST provide its ID. You can only reference emails you sent or received in this conversation (IDs are marked with 'Email ID:').
             */
            reply_to_id: string | null;
            /**
             * Draft Reference Id
             * @description Use this always if you are updating an existing email draft you previously created.
             */
            draft_reference_id: string | null;
        };
        /** DraftSendEmailResponse */
        DraftSendEmailResponse: {
            /**
             * Response Role
             * @default draft_send_email
             * @constant
             */
            response_role: "draft_send_email";
            /** Status */
            status: string;
        };
        /**
         * DraftSlackSendMessage
         * @description Create a draft of a Slack message to send to a channel, DM, or as a reply.
         */
        DraftSlackSendMessage: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: DraftSlackSendMessageRole;
            /**
             * Channel
             * @description The channel ID or name (both work) to send the message to. For DMs, use the user ID.
             */
            channel: string;
            /**
             * Message
             * @description The message to send. Simple markdown formatting is supported.
             */
            message: string;
            /**
             * Thread Ts
             * @description Optional timestamp of a message to reply to in a thread.
             */
            thread_ts: string | null;
            /**
             * Draft Reference Id
             * @description If provided, updates an existing draft instead of creating a new one.
             */
            draft_reference_id: string | null;
        };
        /**
         * DraftSlackSendMessageResponse
         * @description Response for creating a Slack message draft.
         */
        DraftSlackSendMessageResponse: {
            /**
             * Response Role
             * @default draft_slack_send_message
             * @constant
             */
            response_role: "draft_slack_send_message";
            /**
             * Status
             * @description Status message about the draft creation/update
             */
            status: string;
        };
        /**
         * DraftStatus
         * @enum {string}
         */
        DraftStatus: DraftStatus;
        /** DraftSuggestionChangeInput */
        DraftSuggestionChangeInput: {
            /**
             * System User Message Id
             * @description The id of the UserMessage with shown_to='only_client' that you can await later
             */
            system_user_message_id: string;
            /**
             * Autosuggestion
             * @description One of the texts provided as suggestion before
             */
            autosuggestion: string;
            /**
             * Draft Id
             * @description The draft reference id
             */
            draft_id: string;
            /** Thread Id */
            thread_id: string;
        };
        /** DraftSuggestionChangeOutput */
        DraftSuggestionChangeOutput: {
            /** System User Message Id */
            system_user_message_id: string;
        };
        /**
         * DraftUseWebAgent
         * @description Use for tasks requiring a browser (e.g., setting up accounts, registering, finding specific info, downloading invoices, buying things, checking emails).
         *     Similiar to use_web_agent, but this version of the tool is for active actions like filling out a form, buying, refunding something... The non-draft version is for information retrieval tasks like checking the status of something.
         *     This tool will propose the user a draft of the task, and will the user the opportunity to change the draft and the task will only actually start once the user approves the draft.
         */
        DraftUseWebAgent: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: DraftUseWebAgentRole;
            /** Reasoning */
            reasoning: string;
            /**
             * Task
             * @description Natural-language description of the agent's task. Don't use lists.
             */
            task: string;
            /**
             * File Uris
             * @description URI's of files that the agent will need.
             */
            file_uris: string[];
            /**
             * Draft Reference Id
             * @description Use this always if you are updating an existing web agent draft task you previously created.
             */
            draft_reference_id: string | null;
        };
        /** DraftUseWebAgentResponse */
        DraftUseWebAgentResponse: {
            /**
             * Response Role
             * @default draft_use_web_agent
             * @constant
             */
            response_role: "draft_use_web_agent";
            /** Status */
            status: string;
        };
        /**
         * EditAgentFile
         * @description Edits an existing agent file by replacing content at specified line numbers.
         */
        EditAgentFile: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: EditAgentFileRole;
            /**
             * Path
             * @description The path of the file to edit, including filename
             */
            path: string;
            /**
             * New Content
             * @description The new content to replace the specified lines. Should be markdown formatted.
             */
            new_content: string;
            /**
             * Start Line
             * @description The starting line number for the edit
             */
            start_line: number;
            /**
             * End Line
             * @description The ending line number for the edit (exclusive)
             */
            end_line: number;
        };
        /** EditAgentFileResponse */
        EditAgentFileResponse: {
            /**
             * Response Role
             * @default edit_agent_file
             * @constant
             */
            response_role: "edit_agent_file";
            /** Content */
            content: string;
        };
        /** EditDraftsMessage */
        EditDraftsMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: EditDraftsMessageRole;
            transaction: components["schemas"]["EditTransaction-Output"];
        };
        /** EditDraftsRequest */
        EditDraftsRequest: {
            /** Id */
            id: string;
            transaction: components["schemas"]["EditTransaction-Input"];
        };
        /** EditDraftsResponse */
        EditDraftsResponse: {
            /** Id */
            id: string;
        };
        /** EditTransaction */
        "EditTransaction-Input": {
            /** Sync */
            sync: components["schemas"]["SubSyncAction"][];
        };
        /** EditTransaction */
        "EditTransaction-Output": {
            /** Sync */
            sync: components["schemas"]["SubSyncAction"][];
        };
        /** EmailDetails */
        EmailDetails: {
            /**
             * Id
             * @description Unique identifier for the email
             */
            id: string;
            /**
             * Body
             * @description The main content of the email in markdown
             */
            body: string | null;
            /**
             * Html Body
             * @description The raw html body content of the email
             */
            html_body: string | null;
            /**
             * Subject
             * @description Subject line of the email
             */
            subject: string;
            /**
             * From Name
             * @description Name of the email sender
             */
            from_name: string | null;
            /**
             * From Address
             * @description Email address of the sender
             */
            from_address: string;
            /**
             * To Addresses
             * @description List of recipient email addresses
             * @default []
             */
            to_addresses: string[];
            /**
             * To Names
             * @description List of recipient names
             * @default []
             */
            to_names: string[];
            /**
             * Cc Addresses
             * @description List of CC recipient email addresses
             * @default []
             */
            cc_addresses: string[];
            /**
             * Cc Names
             * @description List of CC recipient names
             * @default []
             */
            cc_names: string[];
            /**
             * Bcc Addresses
             * @description List of BCC recipient email addresses
             * @default []
             */
            bcc_addresses: string[];
            /**
             * Bcc Names
             * @description List of BCC recipient names
             * @default []
             */
            bcc_names: string[];
            /**
             * Send Date
             * @description Date and time when the email was sent
             */
            send_date: string;
            /**
             * Attachments
             * @description List of file attachments
             * @default []
             */
            attachments: components["schemas"]["UnifiedUri"][];
            /**
             * Thread Id
             * @description The id of the jace thread this email belongs to
             */
            thread_id: string | null;
            /**
             * Gmail Thread Id
             * @description The id in google's api for this gmail thread
             */
            gmail_thread_id: string | null;
            /**
             * Email Category
             * @description Category of the email
             */
            email_category: string | null;
            /**
             * Email Category Reason
             * @description Reason for the email categorization
             */
            email_category_reason: string | null;
            /**
             * Is First In Thread
             * @description Indicates if this is the first email of a thread
             * @default false
             */
            is_first_in_thread: boolean;
            /**
             * Is Sent By User
             * @description Duplicate field, Deprecated
             * @default false
             */
            is_sent_by_user: boolean;
            /**
             * Is Sent
             * @description Indicates if the email has been sent by the user
             * @default true
             */
            is_sent: boolean;
            /**
             * Labels
             * @description List of gmail generated labels associated with the email
             * @default []
             */
            labels: string[];
            /**
             * Fold At Line
             * @description The line number where the footer starts, 0-indexed
             */
            fold_at_line: number | null;
            /**
             * Position In Thread
             * @description The position of this email in the thread, 0-based index
             */
            position_in_thread: number | null;
        };
        /** EmailInfo */
        EmailInfo: {
            /**
             * Type
             * @default email
             * @constant
             */
            type: "email";
            /**
             * Is Chain Added
             * @default false
             */
            is_chain_added: boolean;
            /** Forward Id */
            forward_id: string | null;
            /** Send At */
            send_at: string | null;
            /** Gmail Draft Id */
            gmail_draft_id: string | null;
            /** Gmail Draft Message Id */
            gmail_draft_message_id: string | null;
        };
        /**
         * EmailThreadStatus
         * @enum {string}
         */
        EmailThreadStatus: EmailThreadStatus;
        /** ErrorMessage */
        ErrorMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: ErrorMessageRole;
            /** Content */
            content: string;
            /** Short Content */
            short_content: string | null;
            /** Error Type */
            error_type: ErrorMessageError_type | null;
        };
        /** FailedTool */
        FailedTool: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: FailedToolRole;
            /** Failed Tool */
            failed_tool: string;
        };
        /** FailedToolResponse */
        FailedToolResponse: {
            /**
             * Response Role
             * @default failed_tool
             * @constant
             */
            response_role: "failed_tool";
            /** Warning */
            warning: string;
        };
        /**
         * FileMetadata
         * @description Metadata of a file. New version, should be filled via our new db model.
         *     This is now used as a response for the file metadata endpoint.
         */
        FileMetadata: {
            unified_uri: components["schemas"]["UnifiedUri"];
            /** Name */
            name: string;
            /** Size */
            size: number;
            /** Mime Type */
            mime_type: string | null;
        };
        /** FileMetadataGetResponse */
        FileMetadataGetResponse: {
            metadata: components["schemas"]["FileMetadata"];
        };
        /** FileMetadataUpdateRequest */
        FileMetadataUpdateRequest: {
            /** Unified Uri Str */
            unified_uri_str: string;
            /** New Path */
            new_path: string | null;
            /** New Thread Id */
            new_thread_id: string | null;
        };
        /** FileMetadataUpdateResponse */
        FileMetadataUpdateResponse: {
            /** Unified Uri Str */
            unified_uri_str: string;
        };
        /** FileUri */
        FileUri: string;
        /**
         * FileUriToLocal
         * @description Downloads a file_uri to the machine
         */
        FileUriToLocal: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: FileUriToLocalRole;
            /**
             * File Uri
             * @description The file uri that should be downloaded to the local machine
             */
            file_uri: string;
            /**
             * New Local Path
             * @description The new local path to use for the file. If not provided, the original file name will be used.
             */
            new_local_path: string | null;
        };
        /** FileUriToLocalResponse */
        FileUriToLocalResponse: {
            /** Content */
            content: string;
        };
        /**
         * FilterView
         * @description A filtered view of all threads, used to show the user a subset of threads
         */
        FilterView: {
            /** Id */
            id: string;
            /** User Id */
            user_id: string | null;
            /** Display Name */
            display_name: string;
            /** Description */
            description: string | null;
            /**
             * Query
             * @description Gmail-style query string, e.g. 'label:IMPORTANT -label:TRASH'
             * @default
             */
            query: string;
            kind: components["schemas"]["FilterViewKind"];
            /** Group */
            group: string;
            /**
             * Visible
             * @default true
             */
            visible: boolean;
            /** Icon */
            icon: string | null;
            /**
             * Position
             * @default 1000
             */
            position: number;
            /** Created At */
            created_at: string | null;
            /** Updated At */
            updated_at: string | null;
            /**
             * Deleted
             * @default false
             */
            deleted: boolean;
            /**
             * Automatic Draft
             * @description Whether to automatically generate drafts for emails in this view
             * @default false
             */
            automatic_draft: boolean;
        };
        /** FilterViewCreate */
        FilterViewCreate: {
            /** Id */
            id: string;
            /** Display Name */
            display_name: string;
            kind: components["schemas"]["FilterViewKind"];
            /** Group */
            group: string;
            /** Description */
            description: string | null;
            /**
             * Query
             * @description Gmail-style query string, e.g. 'label:IMPORTANT -label:TRASH'
             * @default
             */
            query: string;
            /**
             * Visible
             * @default true
             */
            visible: boolean;
            /** Icon */
            icon: string | null;
            /**
             * Position
             * @default 1000
             */
            position: number;
            /**
             * Automatic Draft
             * @description Whether to automatically generate drafts for emails in this view
             * @default false
             */
            automatic_draft: boolean;
        };
        /**
         * FilterViewKind
         * @enum {string}
         */
        FilterViewKind: FilterViewKind;
        /** FilterViewUpdate */
        FilterViewUpdate: {
            /** Display Name */
            display_name: string | null;
            /** Description */
            description: string | null;
            /** Query */
            query: string | null;
            kind: components["schemas"]["FilterViewKind"] | null;
            /** Group */
            group: string | null;
            /** Visible */
            visible: boolean | null;
            /** Icon */
            icon: string | null;
            /** Position */
            position: number | null;
            /** Deleted */
            deleted: boolean | null;
            /** Automatic Draft */
            automatic_draft: boolean | null;
        };
        /**
         * GetEmailLabels
         * @description Retrieves the labels for a specific email.
         */
        GetEmailLabels: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: GetEmailLabelsRole;
            /**
             * Email Ids
             * @description List of IDs of the email message or threads to get labels for. This should be an ID marked with 'Email ID:' or a thread id from a unified uri, for example gmail://threads/AAA/0/email.md the thread id is AAA.
             */
            email_ids: string[];
        };
        /**
         * GetEmailLabelsResponse
         * @description Response for GetEmailLabels tool.
         */
        GetEmailLabelsResponse: {
            /**
             * Response Role
             * @default get_email_labels
             * @constant
             */
            response_role: "get_email_labels";
            /**
             * Status
             * @description Detailed results showing which emails have which labels in a structured format
             */
            status: string;
        };
        /**
         * GetMessagesByIdsRequest
         * @description Request model for getting messages by their IDs
         */
        GetMessagesByIdsRequest: {
            /**
             * Message Ids
             * @description List of message IDs to fetch
             */
            message_ids: string[];
        };
        /**
         * GetThreadsByIdsRequest
         * @description Request model for getting threads by their IDs
         */
        GetThreadsByIdsRequest: {
            /**
             * Thread Ids
             * @description List of thread IDs to fetch
             */
            thread_ids: string[];
        };
        /** GmailEmailResponse */
        GmailEmailResponse: {
            /** Id */
            id: string;
            /** Gmail Thread Id */
            gmail_thread_id: string | null;
            /** Thread Id */
            thread_id: string | null;
        };
        /**
         * GmailLabel
         * @description Model for a Gmail label.
         */
        GmailLabel: {
            /** Id */
            id: string;
            /** Name */
            name: string;
            /**
             * Messagelistvisibility
             * @default show
             */
            messageListVisibility: string;
            /**
             * Labellistvisibility
             * @default labelHide
             */
            labelListVisibility: string;
            /**
             * Type
             * @default user
             */
            type: string;
            /**
             * Source
             * @default gmail
             */
            source: string;
            /** Messagestotal */
            messagesTotal: number | null;
            /** Messagesunread */
            messagesUnread: number | null;
            /** Threadstotal */
            threadsTotal: number | null;
            /** Threadsunread */
            threadsUnread: number | null;
            color: components["schemas"]["GmailLabelColor"] | null;
        };
        /**
         * GmailLabelColor
         * @description Model for Gmail label color settings.
         */
        GmailLabelColor: {
            /** Textcolor */
            textColor: string;
            /** Backgroundcolor */
            backgroundColor: string;
        };
        /**
         * GmailLabelCreate
         * @description Input model for creating a Gmail label.
         */
        GmailLabelCreate: {
            /** Name */
            name: string;
            color: components["schemas"]["GmailLabelColor"] | null;
            /**
             * Messagelistvisibility
             * @default show
             */
            messageListVisibility: string;
        };
        /**
         * GmailLabelUpdate
         * @description Input model for updating a Gmail label.
         */
        GmailLabelUpdate: {
            /** Name */
            name: string | null;
            color: components["schemas"]["GmailLabelColor"] | null;
            /** Messagelistvisibility */
            messageListVisibility: string | null;
            /** Labellistvisibility */
            labelListVisibility: string | null;
        };
        /**
         * GmailLabelVisibilityToggle
         * @description Input model for toggling visibility of ZETA labels.
         */
        GmailLabelVisibilityToggle: {
            /**
             * Show
             * @description If True, shows all ZETA labels in message list. If False, hides them.
             */
            show: boolean;
        };
        /**
         * GoogleCalendarDeleteEvent
         * @description Now used as SystemTool as applied tool in submit_drafts for the draft tool DraftGoogleCalendarDeleteEvent.
         */
        GoogleCalendarDeleteEvent: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: GoogleCalendarDeleteEventRole;
            /**
             * Calendar Id
             * @description The ID of the calendar.
             */
            calendar_id: string;
            /**
             * Event Id
             * @description The ID of the event to delete.
             */
            event_id: string;
        };
        /** GoogleCalendarDeleteEventInfo */
        GoogleCalendarDeleteEventInfo: {
            /**
             * Type
             * @default google_calendar_delete_event
             * @constant
             */
            type: "google_calendar_delete_event";
            event: components["schemas"]["GoogleCalendarEvent"] | null;
            /** Draft Id */
            draft_id: string;
            /** Success */
            success: boolean;
        };
        /** GoogleCalendarDeleteEventResponse */
        GoogleCalendarDeleteEventResponse: {
            /**
             * Response Role
             * @default google_calendar_delete_event
             * @constant
             */
            response_role: "google_calendar_delete_event";
            /** Message */
            message: string | null;
        };
        /**
         * GoogleCalendarEvent
         * @description Represents event in the user's calendar. Use to create or update events. When updating an event, provide the id of the event to update.
         */
        GoogleCalendarEvent: {
            /**
             * Id
             * @description Unique identifier for the event. Leave empty when creating a new event; you MUST provide it when updating an existing event (e.g. RSVP, changing the date, etc).
             */
            id: string | null;
            /**
             * Calendar Id
             * @description The ID of the calendar to insert or update the event into. If left empty uses the primary calendar.
             */
            calendar_id: string | null;
            /**
             * Summary
             * @description Title of the event.
             */
            summary: string | null;
            /**
             * Description
             * @description Description or notes for the event.
             */
            description: string | null;
            /**
             * Location
             * @description Geographic location of the event as free-form text.
             */
            location: string | null;
            /**
             * Start Date
             * @description The start date for all-day events.
             */
            start_date: string | null;
            /**
             * Start Datetime
             * @description The start date and time for timed events. Timezone Aware
             */
            start_datetime: string | null;
            /**
             * Start Timezone
             * @description The time zone for the start time. Defaults to the user's timezone.
             */
            start_timezone: string | null;
            /**
             * End Date
             * @description The end date for all-day events.
             */
            end_date: string | null;
            /**
             * End Datetime
             * @description The end date and time for timed events. Timezone Aware
             */
            end_datetime: string | null;
            /**
             * End Timezone
             * @description The time zone for the end time. Defaults to the user's timezone.
             */
            end_timezone: string | null;
            /**
             * Rsvp Response
             * @description If you want to change the RSVP status of the event for the user.
             */
            rsvp_response: GoogleCalendarEventRsvp_response | null;
            /**
             * Attendees
             * @description The attendees of the event. Don't forget to add the users email address if they will be part of the event.
             */
            attendees: components["schemas"]["Attendee"][] | null;
            /**
             * Attendees Emails
             * @description The emails of the attendees of the event.
             */
            attendees_emails: string[] | null;
            /**
             * Recurrence
             * @description List of RRULE, EXRULE, RDATE and EXDATE lines for defining recurrence.
             */
            recurrence: string[] | null;
            /**
             * Hangout Link
             * @description The URL for the hangout of the event, if the event is a hangout/meets.
             */
            hangout_link: string | null;
            /** @description The creator of the event (Read-only) */
            creator: components["schemas"]["Attendee"] | null;
            /**
             * Needs Google Meets
             * @description If set to True, a Google Meet video conference will be added to the event.
             */
            needs_google_meets: boolean | null;
        };
        /**
         * GoogleCalendarFreeTimeSlot
         * @description Represents a free time slot in the user's calendar available for scheduling an event.
         */
        GoogleCalendarFreeTimeSlot: {
            /**
             * Start Datetime
             * Format: date-time
             * @description The start datetime for the free time slot.
             */
            start_datetime: string;
            /**
             * End Datetime
             * Format: date-time
             * @description The end datetime for the free time slot.
             */
            end_datetime: string;
        };
        /** GoogleCalendarFreeTimeSlotsResponse */
        GoogleCalendarFreeTimeSlotsResponse: {
            /**
             * Free Time Slots
             * @description List of free time slots in the user's calendar for the given time range.
             * @default []
             */
            free_time_slots: components["schemas"]["GoogleCalendarFreeTimeSlot"][];
            /**
             * Response Role
             * @default google_calendar_free_time_slots
             * @constant
             */
            response_role: "google_calendar_free_time_slots";
        };
        /** GoogleCalendarListCalendarsResponse */
        GoogleCalendarListCalendarsResponse: {
            /**
             * Calendars
             * @description List of calendars the user has access to.
             * @default []
             */
            calendars: components["schemas"]["Calendar"][];
            /**
             * Response Role
             * @default google_calendar_list_calendars
             * @constant
             */
            response_role: "google_calendar_list_calendars";
        };
        /**
         * GoogleCalendarSchedule
         * @description Fetches calendar events or free time slots within a specific time range.
         */
        GoogleCalendarSchedule: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: GoogleCalendarScheduleRole;
            /**
             * From Datetime
             * @description Start datetime
             */
            from_datetime: string | null;
            /**
             * To Datetime
             * @description End datetime
             */
            to_datetime: string | null;
            /**
             * Schedule Type
             * @description Level of detail: full (all details), free (availability), summary (titles/times).
             * @default full
             * @enum {string}
             */
            schedule_type: GoogleCalendarScheduleSchedule_type;
            /**
             * Display Additional Timezone
             * @description Displays all events in additionaly in provided timezone (i.e America/New_York). Useful for time conversion of availabilities. If not provided, defaults to user timezone.
             */
            display_additional_timezone: string | null;
        };
        /** GoogleCalendarScheduleResponse */
        GoogleCalendarScheduleResponse: {
            /**
             * Content
             * @description xml representation of the calendar schedule for the requested time range.
             */
            content: string | null;
            /**
             * Response Role
             * @default google_calendar_schedule
             * @constant
             */
            response_role: "google_calendar_schedule";
        };
        /** GoogleCalendarSnippet */
        GoogleCalendarSnippet: {
            /**
             * Id
             * @description Unique identifier for the event. Leave empty when creating a new event; you MUST provide it when updating an existing event (e.g. RSVP, changing the date, etc).
             */
            id: string | null;
            /**
             * Calendar Id
             * @description The ID of the calendar to insert or update the event into. If left empty uses the primary calendar.
             */
            calendar_id: string | null;
            /**
             * Summary
             * @description Title of the event.
             */
            summary: string | null;
            /**
             * Description
             * @description Description or notes for the event.
             */
            description: string | null;
            /**
             * Location
             * @description Geographic location of the event as free-form text.
             */
            location: string | null;
            /**
             * Start Date
             * @description The start date for all-day events.
             */
            start_date: string | null;
            /**
             * Start Datetime
             * @description The start date and time for timed events. Timezone Aware
             */
            start_datetime: string | null;
            /**
             * Start Timezone
             * @description The time zone for the start time. Defaults to the user's timezone.
             */
            start_timezone: string | null;
            /**
             * End Date
             * @description The end date for all-day events.
             */
            end_date: string | null;
            /**
             * End Datetime
             * @description The end date and time for timed events. Timezone Aware
             */
            end_datetime: string | null;
            /**
             * End Timezone
             * @description The time zone for the end time. Defaults to the user's timezone.
             */
            end_timezone: string | null;
            /**
             * Rsvp Response
             * @description If you want to change the RSVP status of the event for the user.
             */
            rsvp_response: GoogleCalendarSnippetRsvp_response | null;
            /**
             * Attendees
             * @description The attendees of the event. Don't forget to add the users email address if they will be part of the event.
             */
            attendees: components["schemas"]["Attendee"][] | null;
            /**
             * Attendees Emails
             * @description The emails of the attendees of the event.
             */
            attendees_emails: string[] | null;
            /**
             * Recurrence
             * @description List of RRULE, EXRULE, RDATE and EXDATE lines for defining recurrence.
             */
            recurrence: string[] | null;
            /**
             * Hangout Link
             * @description The URL for the hangout of the event, if the event is a hangout/meets.
             */
            hangout_link: string | null;
            /** @description The creator of the event (Read-only) */
            creator: components["schemas"]["Attendee"] | null;
            /**
             * Needs Google Meets
             * @description If set to True, a Google Meet video conference will be added to the event.
             */
            needs_google_meets: boolean | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: GoogleCalendarSnippetType;
            /**
             * Source Type
             * @description The type of the source that created this snippet. can be 'get_events' or similiar
             */
            source_type: string | null;
            /**
             * Source Id
             * @description The id of the message that triggered this snippet. can be a received_email or a tool response
             */
            source_id: string | null;
        };
        /** GoogleCalendarUpsertEvent */
        GoogleCalendarUpsertEvent: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: GoogleCalendarUpsertEventRole;
            /**
             * Gcal Event Id
             * @description Existing event ID. Omit unless you're updating an event or a draft tied to an event.
             */
            gcal_event_id: string | null;
            /**
             * Calendar Id
             * @description Uses primary if omitted.
             */
            calendar_id: string | null;
            /**
             * Summary
             * @description Event title.
             */
            summary: string;
            /**
             * Description
             * @description Event description or notes.
             */
            description: string | null;
            /**
             * Location
             * @description Event location.
             */
            location: string | null;
            /**
             * Time Zone
             * @description Event timezone. If not provided, the user's timezone will be used.
             */
            time_zone: string | null;
            /**
             * Start Datetime
             * @description Start date/time in ISO 8601.
             */
            start_datetime: string;
            /**
             * End Datetime
             * @description End date/time in ISO 8601.
             */
            end_datetime: string;
            /**
             * Rsvp Response
             * @description Set the user's RSVP status.
             */
            rsvp_response: GoogleCalendarUpsertEventRsvp_response | null;
            /**
             * Attendees Emails
             * @description Full list of attendee emails. Don't forget to add the user's email.
             */
            attendees_emails: string[] | null;
            /**
             * Needs Google Meets
             * @description If true, creates a Google Meet link.
             */
            needs_google_meets: boolean | null;
        };
        /** GoogleCalendarUpsertEventInfo */
        GoogleCalendarUpsertEventInfo: {
            /**
             * Type
             * @default google_calendar_upsert_event
             * @constant
             */
            type: "google_calendar_upsert_event";
            event: components["schemas"]["GoogleCalendarEvent"] | null;
            /** Is Existing Event */
            is_existing_event: boolean;
            /** Draft Id */
            draft_id: string;
            /** Success */
            success: boolean | null;
        };
        /** GoogleCalendarUpsertEventResponse */
        GoogleCalendarUpsertEventResponse: {
            /**
             * Response Role
             * @default google_calendar_upsert_event
             * @constant
             */
            response_role: "google_calendar_upsert_event";
            /** Message */
            message: string;
            /** @description The event after insertion or update. */
            event: components["schemas"]["GoogleCalendarEvent"] | null;
            /**
             * Overlapping Events
             * @description List of overlapping events.
             */
            overlapping_events: components["schemas"]["GoogleCalendarEvent"][] | null;
        };
        /** HTTPValidationError */
        HTTPValidationError: {
            /** Detail */
            detail: components["schemas"]["ValidationError"][];
        };
        /** InboxBackfillStatusResponse */
        InboxBackfillStatusResponse: {
            /**
             * Status
             * @enum {string}
             */
            status: InboxBackfillStatusResponseStatus;
            /** Threads Count */
            threads_count: number;
            /** Threads Imported */
            threads_imported: number;
            /** Threads Failed */
            threads_failed: number;
            /**
             * Suggested Rules
             * @default []
             */
            suggested_rules: string[];
        };
        /** InputWidget */
        InputWidget: {
            /** Data */
            data: components["schemas"]["PrimitiveInputRole"] | components["schemas"]["SelectInputRole"];
        };
        /**
         * InputWidgetMessage
         * @description After an AssistantMessage, we provide optionally a few input widgets. (or Autosuggestions, bot not both)
         */
        InputWidgetMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: InputWidgetMessageRole;
            /** Input Widgets */
            input_widgets: components["schemas"]["InputWidget"][];
            /** Response To Id */
            response_to_id: string;
        };
        /** IntegrationResponse */
        IntegrationResponse: {
            /** Url */
            url: string;
            /** Disconnect Url */
            disconnect_url: string;
            /** Name */
            name: string;
            /** Is Connected */
            is_connected: boolean;
            /** Logo Url */
            logo_url: string;
        };
        /** LastLengthMessage */
        LastLengthMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: LastLengthMessageRole;
            /** Length */
            length: number;
        };
        /**
         * ListAgentFiles
         * @description Lists all agent files that are available to the agent.
         */
        ListAgentFiles: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: ListAgentFilesRole;
        };
        /** ListAgentFilesResponse */
        ListAgentFilesResponse: {
            /**
             * Response Role
             * @default list_agent_files
             * @constant
             */
            response_role: "list_agent_files";
            /**
             * Files
             * @description List of file paths
             */
            files: string[];
        };
        /**
         * LocalToFileUri
         * @description Uploads a local file from the machine to a file URI
         */
        LocalToFileUri: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: LocalToFileUriRole;
            /**
             * Path
             * @description The local file path that should be uploaded
             */
            path: string;
            /**
             * New File Name
             * @description The new file name to use for the file URI. If not provided, the original file name will be used.
             */
            new_file_name: string | null;
        };
        /** LocalToFileUriResponse */
        LocalToFileUriResponse: {
            /** Content */
            content: string;
        };
        /** LoginAffiliateUserRequest */
        LoginAffiliateUserRequest: {
            /** Email */
            email: string;
            /** Otp */
            otp: string;
        };
        /** LoginAffiliateUserResponse */
        LoginAffiliateUserResponse: {
            /** Jwt */
            jwt: string;
        };
        /**
         * MachineMessage
         * @description Defines that we have a machine instance already for this thread.
         */
        MachineMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: MachineMessageRole;
            /** Instance Id */
            instance_id: string;
        };
        /**
         * MetadataResponse
         * @description Response model for database metadata endpoint
         */
        MetadataResponse: {
            /**
             * Schema Version
             * @description Combined version string in format 'global:local' where:
             *     - global: The global data version that determines if local DB needs reset
             *     - local: The user's local DB version
             */
            schema_version: string;
        };
        /**
         * NoMoreToolCallsMessage
         * @description Message to indicate that there are no more tool calls in this tool call group. this means we can unblock the user here.
         */
        NoMoreToolCallsMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: NoMoreToolCallsMessageRole;
            /** Tool Call Group Id */
            tool_call_group_id: string;
        };
        /** NotionPageResponse */
        NotionPageResponse: {
            /** Notion Page Response */
            notion_page_response: string;
            /**
             * Response Role
             * @default notion_page
             * @constant
             */
            response_role: "notion_page";
        };
        /**
         * OpenAgentFile
         * @description Opens and returns the content of an agent file.
         */
        OpenAgentFile: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: OpenAgentFileRole;
            /**
             * Path
             * @description The path of the file to open, including filename
             */
            path: string;
        };
        /** OpenAgentFileResponse */
        OpenAgentFileResponse: {
            /**
             * Response Role
             * @default open_agent_file
             * @constant
             */
            response_role: "open_agent_file";
            /** Content */
            content: string;
        };
        /**
         * OpenFile
         * @description Opens and reads content from files, images, webpages, or emails (supports line-range filtering) etc. In general you can open anything with a unified uri.
         *     Our unified uris start with 'files://', 'gmail://', 'notion://', 'slack://' etc.. With this tool you can also use 'http://' / 'https://' to directly open web pages (but only of somewhat static websites without much client side javascript).
         */
        OpenFile: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: OpenFileRole;
            /**
             * Unified Uri
             * @description The unified uri or web url to open.
             */
            unified_uri: string;
            /**
             * Line Start
             * @description Starting line number (0-based) of the content you want to read. If not provided, the entire file will be read.
             */
            line_start: number | null;
            /**
             * Line End
             * @description Ending line number (exclusive) of the content you want to read. If not provided, the entire file will be read.
             */
            line_end: number | null;
        };
        /** OpenFileResponse */
        OpenFileResponse: {
            /**
             * Response Role
             * @default open_file
             * @constant
             */
            response_role: "open_file";
            /**
             * Content
             * @description Text content of the file if available
             */
            content: string | null;
            /**
             * Error
             * @description Error message if the operation failed
             */
            error: string | null;
        };
        /** OutOfCreditsMessage */
        OutOfCreditsMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: OutOfCreditsMessageRole;
            /** Credit Warning */
            credit_warning: string;
        };
        /** PartialToolCallMessage */
        PartialToolCallMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: PartialToolCallMessageRole;
            /** Tool Id */
            tool_id: string;
            /** Tool Call Group Id */
            tool_call_group_id: string;
            /** Tool */
            tool: {
                [key: string]: unknown;
            };
        };
        /**
         * PersonEssayRequest
         * @description Request model for generating a detailed essay about a person.
         */
        PersonEssayRequest: {
            /**
             * Person Name
             * @description The name of the person to analyze
             */
            person_name: string;
            /**
             * Person Text
             * @description Additional context or information about the person
             * @default
             */
            person_text: string;
        };
        /**
         * PersonalityAnalysisRequest
         * @description Request model for initializing a personality analysis thread.
         */
        PersonalityAnalysisRequest: {
            /**
             * Optimistic Prompt
             * @description The client-only user message content
             */
            optimistic_prompt: string;
            /**
             * Thread Id
             * @description The ID of the thread to create
             */
            thread_id: string;
            /**
             * Message Id
             * @description The message ID of the optimistic prompt user message
             */
            message_id: string;
        };
        /** PlanGoalSimple */
        PlanGoalSimple: {
            /** Id */
            id: string;
            /** Content */
            content: string;
            /** Status */
            status: string;
        };
        /** PlanStepDoneResponse */
        PlanStepDoneResponse: {
            /**
             * Response Role
             * @default plan_step_done
             * @constant
             */
            response_role: "plan_step_done";
            /** Status */
            status: string;
        };
        /**
         * PrimitiveInputResponse
         * @description User filled out this input widget. For example: label: "how many shoes do you have?" value: "5"
         */
        PrimitiveInputResponse: {
            /**
             * Role
             * @default primitive_input
             * @constant
             */
            role: "primitive_input";
            /** Label */
            label: string;
            /** Value */
            value: string;
        };
        /** PrimitiveInputRole */
        PrimitiveInputRole: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: PrimitiveInputRoleRole;
            /** Label */
            label: string;
            /**
             * Placeholder
             * @description Placeholder text for the input field
             * @default
             */
            placeholder: string;
            /**
             * Type
             * @description This is a legacy field and will always be 'string'.
             * @default string
             * @enum {string}
             */
            type: PrimitiveInputRoleType;
        };
        /** ProfitDataPoint */
        ProfitDataPoint: {
            /** Date */
            date: string;
            /** Amount */
            amount: number;
        };
        /**
         * QuickAiSearch
         * @description Answers a specific question using a single Google search and the first 3 results. Present your findings to the user in a bulleted list or table.
         */
        QuickAiSearch: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: QuickAiSearchRole;
            /** Search Question */
            search_question: string;
        };
        /** QuickAiSearchResponse */
        QuickAiSearchResponse: {
            /** Search Response */
            search_response: string;
            /**
             * Response Role
             * @default quick_ai_search
             * @constant
             */
            response_role: "quick_ai_search";
        };
        /**
         * QuickAiSearchResponseInfo
         * @description Gives some extra info about the search results
         */
        QuickAiSearchResponseInfo: {
            /**
             * Response Role
             * @default quick_ai_search
             * @constant
             */
            response_role: "quick_ai_search";
            /** Preview Links */
            preview_links: string[] | null;
        };
        /** ReadStatus */
        ReadStatus: {
            /** Id */
            id: string;
            /** Thread Id */
            thread_id: string;
            /** Email Id */
            email_id: string;
            /**
             * Read At
             * Format: date-time
             */
            read_at: string;
            /**
             * Created At
             * Format: date-time
             */
            created_at: string;
            /**
             * Updated At
             * Format: date-time
             */
            updated_at: string;
        };
        /** ReceivedEmailMessage */
        ReceivedEmailMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: ReceivedEmailMessageRole;
            email: components["schemas"]["EmailDetails"];
            /** Is From User */
            is_from_user: boolean;
            /** Draft Id */
            draft_id: string | null;
            /**
             * Prefer Body Markdown
             * @description Deprecated field - no longer used
             */
            prefer_body_markdown: boolean | null;
            /** Gcal Event Id */
            gcal_event_id: string | null;
            /** Gcal Calendar Id */
            gcal_calendar_id: string | null;
            /**
             * Read At
             * @description The time the email was read
             */
            read_at: string | null;
        };
        /**
         * RecurringActivation
         * @description Schedule yourself to be reactivated and then being able to act again based on the frequency, which should be a valid cron string.
         *     At that time you will be able to use any combination of your tools again.
         *     If the schedule description does not indicate that the schedule should repeat (e.g. 'next Monday'), set do_not_repeat to True.
         *     Use only as the last tool.
         */
        RecurringActivation: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: RecurringActivationRole;
            /**
             * Cron String
             * @description e.g., '0 9 * * *'
             */
            cron_string: string;
            /**
             * Do Not Repeat
             * @description If True, the task will only be scheduled once.
             * @default false
             */
            do_not_repeat: boolean;
        };
        /** ReducedEditsMessage */
        ReducedEditsMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: ReducedEditsMessageRole;
            /** Tool */
            tool: components["schemas"]["DraftSendEmail"] | components["schemas"]["DraftGoogleCalendarUpsertEvent"] | components["schemas"]["DraftGoogleCalendarDeleteEvent"] | components["schemas"]["DraftSlackSendMessage"] | components["schemas"]["GoogleCalendarUpsertEvent"];
            /** Draft Id */
            draft_id: string;
            /** Models Id */
            models_id: string;
            status: components["schemas"]["DraftStatus"] | null;
            /** Info */
            info: components["schemas"]["EmailInfo"] | components["schemas"]["CalendarInfo"] | components["schemas"]["SlackInfo"] | components["schemas"]["DeleteCalendarInfo"] | null;
            /**
             * Modified
             * @default false
             */
            modified: boolean;
        };
        /** ReferralCodeInput */
        ReferralCodeInput: {
            /** Referral Code */
            referral_code: string;
        };
        /**
         * RelevantConversationMessage
         * @description Contains relevant conversation snippets that can be converted to user messages during preparation.
         *     Only the most recent one of these messages should be used.
         */
        RelevantConversationMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: RelevantConversationMessageRole;
            /** Conversations */
            conversations: string[];
        };
        /** Rule */
        Rule: {
            /** Id */
            id: string;
            /** User Id */
            user_id: string;
            /** Condition */
            condition: string | null;
            /** Content */
            content: string;
            /** Unified Uris */
            unified_uris: components["schemas"]["UnifiedUri"][] | null;
            /**
             * Rule Status
             * @default active
             * @enum {string}
             */
            rule_status: RuleRule_status;
        };
        /** RuleCreate */
        RuleCreate: {
            /** Condition */
            condition: string | null;
            /** Content */
            content: string;
            /** Unified Uris */
            unified_uris: string[] | null;
        };
        /** RuleSuggestionMessage */
        RuleSuggestionMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: RuleSuggestionMessageRole;
            /** Rule Id */
            rule_id: string;
            /** Condition */
            condition: string | null;
            /** Content */
            content: string | null;
            /** Unified Uris */
            unified_uris: string[] | null;
        };
        /** RuleUpdate */
        RuleUpdate: {
            /** Condition */
            condition: string | null;
            /** Content */
            content: string | null;
            /** Unified Uris */
            unified_uris: string[] | null;
            /**
             * Rule Status
             * @default active
             * @enum {string}
             */
            rule_status: RuleUpdateRule_status;
        };
        /** ScheduleSendRequest */
        ScheduleSendRequest: {
            /** Draft Message Id */
            draft_message_id: string;
        };
        /** ScheduledTaskResponse */
        ScheduledTaskResponse: {
            /**
             * Response Role
             * @default scheduled_task
             * @constant
             */
            response_role: "scheduled_task";
            /** Status */
            status: string;
        };
        /**
         * SearchEmailContacts
         * @description Search email history for contacts by name or email fragment.
         *     For multiple people, always search at once with a list of strings to save time.
         */
        SearchEmailContacts: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: SearchEmailContactsRole;
            /**
             * Query
             * @description Name or partial email/domain (e.g., 'John', 'Doe', 'company.com'). The list can contain one or multiple strings to search for multiple contacts simultaneously.
             */
            query: string[];
        };
        /** SearchEmailContactsResponse */
        SearchEmailContactsResponse: {
            /**
             * Contacts
             * @description List of found contacts with their details
             * @default []
             */
            contacts: components["schemas"]["manager__ai_datatypes__EmailContact"][];
            /**
             * Response Role
             * @default search_email_contacts
             * @constant
             */
            response_role: "search_email_contacts";
        };
        /**
         * SearchEmails
         * @description Searches emails based on a detailed search query. This uses a semantic search if you provide a query.
         *     You cannot search for things like 'latest' or 'recent' as these are meaningless for an embedding model. If you need specific timeframes, rather use the other parameters and not use the query.
         */
        SearchEmails: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: SearchEmailsRole;
            /**
             * Search Query
             * @description Detailed search query text that will be used for embedding search. Can be very conversational. i.e. 'Information about who my investors are'. Optional, if not provided, we will directly query the database for all emails that match the other parameters. This can be powerful when you just want to get any conversation and not a specific topic.
             */
            search_query: string | null;
            /**
             * Start Date
             * @description Start date (YYYY-MM-DD), inclusive, filter, optional
             */
            start_date: string | null;
            /**
             * End Date
             * @description End date (YYYY-MM-DD), inclusive, filter, optional
             */
            end_date: string | null;
            /**
             * Sender Email
             * @description Sender's email, filter, optional
             */
            sender_email: string | null;
            /**
             * Recipient Email
             * @description Either one of the to's email or cc's email or bcc's email, filter, optional
             */
            recipient_email: string | null;
            /**
             * Has Attachments
             * @description Filter for emails with attachments
             */
            has_attachments: boolean | null;
            /**
             * Before
             * @description Number of emails to include before each relevant email result
             * @default 2
             */
            before: number;
            /**
             * After
             * @description Number of emails to include after each relevant email result
             * @default 2
             */
            after: number;
            /**
             * Max Results
             * @description Maximum number of results to return (up to 100)
             * @default 10
             */
            max_results: number;
        };
        /** SearchEmailsResponse */
        SearchEmailsResponse: {
            /**
             * Response Role
             * @default search_emails
             * @constant
             */
            response_role: "search_emails";
            /** Content */
            content: string;
        };
        /**
         * SearchFile
         * @description Runs a semantic search for query over the contents of a file or folder specified by a UnifiedUri.
         *     This retrieves chunks and images from the files for you to read.
         *     Guidelines:
         *     - Search multiple files by setting the `unified_uri` to a folder, for example 'files://user/test_folder'
         *     - Search a single file by setting the `unified_uri` to a file you KNOW exists, for example 'files://user/test_folder/test_file.txt'
         *     - The query should ideally be a longer sentence so the semantic search works correctly.
         */
        SearchFile: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: SearchFileRole;
            /**
             * Query
             * @description The string to search for.
             */
            query: string;
            /**
             * Unified Uri
             * @description The UnifiedUri of the file to search in.
             */
            unified_uri: string;
        };
        /** SearchFileResponse */
        SearchFileResponse: {
            /**
             * Response Role
             * @default search_file
             * @constant
             */
            response_role: "search_file";
            /**
             * Content
             * @description Search results
             */
            content: string | null;
            /**
             * Error
             * @description Error message if the operation failed
             */
            error: string | null;
        };
        /**
         * SearchGmail
         * @description Semantic search over emails. Returns matching emails plus context (2 before, 2 after). Set `use_agent=True` for deeper multi-step searches that require intelligent filtering (for example important, urgent, angry emails etc.) or if you are not confident you would find the right emails on the first try.
         */
        SearchGmail: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: SearchGmailRole;
            /**
             * Search Query
             * @description Semantic query describing clearly what you're looking for. Use dedicated parameters instead of search operators. Up to 3 sentences. Leave empty if you want the 8 most recent emails in the specified range.
             */
            search_query: string | null;
            /**
             * Start Date
             * @description Start date (YYYY-MM-DD), inclusive, filter, optional
             */
            start_date: string | null;
            /**
             * End Date
             * @description End date (YYYY-MM-DD), inclusive, filter, optional
             */
            end_date: string | null;
            /**
             * Sender Email
             * @description Sender's email, filter, optional
             */
            sender_email: string | null;
            /**
             * Recipient Email
             * @description Either one of the to's email or cc's email or bcc's email, filter, optional
             */
            recipient_email: string | null;
            /**
             * Use Agent
             * @description Set true for deeper, comprehensive search; slower but thorough.
             * @default false
             */
            use_agent: boolean;
        };
        /** SearchGmailResponse */
        SearchGmailResponse: {
            /** Search Response */
            search_response: string;
            /**
             * Response Role
             * @default search_gmail
             * @constant
             */
            response_role: "search_gmail";
        };
        /**
         * SearchNotion
         * @description Searches notion pages based on a query.
         */
        SearchNotion: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: SearchNotionRole;
            /**
             * Query
             * @description The query to search for
             */
            query: string;
        };
        /** SearchNotionResponse */
        SearchNotionResponse: {
            /** Content */
            content: string;
            /**
             * Response Role
             * @default search_notion
             * @constant
             */
            response_role: "search_notion";
        };
        /**
         * SearchSlack
         * @description Search Slack messages using advanced query operators.
         */
        SearchSlack: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: SearchSlackRole;
            /**
             * Query
             * @description Slack-formatted search query. Use quotation marks for exact phrases. Use dash (-) to exclude words. Use from:@user or with:@user for specific users. Use in:#channel for specific channels (optional, dont make up channels). Use before:, after:, or on: for date filtering. `OR`,`AND` and similiar are not supported. By default usually good to start to search only in the last 3 months.Example query: '"project zeus" update from:@Alice in:#team-updates after:2024-01-01'
             */
            query: string;
        };
        /**
         * SearchSlackResponse
         * @description Response for searching Slack messages (pre-formatted text).
         */
        SearchSlackResponse: {
            /**
             * Response Role
             * @default search_slack
             * @constant
             */
            response_role: "search_slack";
            /** Content */
            content: string;
        };
        /**
         * SelectInputResponse
         * @description User selected options in this select input widget. For example: label: "what is your favorite color?" options:["green", "blue", "red"] selected_options: ["blue", "red"]
         */
        SelectInputResponse: {
            /**
             * Role
             * @default select_input
             * @constant
             */
            role: "select_input";
            /** Label */
            label: string;
            /** Options */
            options: string[];
            /** Selected Options */
            selected_options: string[];
        };
        /** SelectInputRole */
        SelectInputRole: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: SelectInputRoleRole;
            /** Label */
            label: string;
            /**
             * Options
             * @description The options for the selection
             */
            options: string[];
            /**
             * Multiple
             * @description True if multiple selections are allowed, False for single selection
             * @default false
             */
            multiple: boolean;
        };
        /**
         * SendEmail
         * @description Sends an email to the specified recipient(s) with the given subject and body.
         */
        SendEmail: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: SendEmailRole;
            /** To */
            to: string[];
            /** Cc */
            cc: string[];
            /** Bcc */
            bcc: string[];
            /** Subject */
            subject: string | null;
            /** Body */
            body: string;
            /** Html Body */
            html_body: string | null;
            /** File Uris Attachments */
            file_uris_attachments: string[];
            /** Forwarded Email Id */
            forwarded_email_id: string | null;
            /**
             * Reply To Id
             * @description An ID of the email you are replying to. If you are not replying to any of the emails that you see, leave as `None`.
             */
            reply_to_id: string | null;
        };
        /** SendEmailResponse */
        SendEmailResponse: {
            /**
             * Response Role
             * @default send_email
             * @constant
             */
            response_role: "send_email";
            /** Status */
            status: string;
        };
        /** SendEmailResponseInfo */
        SendEmailResponseInfo: {
            /**
             * Response Role
             * @default send_email
             * @constant
             */
            response_role: "send_email";
            /** Message Id */
            message_id: string;
            /**
             * Final Body Markdown
             * @description The final body of the email in markdown format.
             */
            final_body_markdown: string | null;
        };
        /** SendMagicLinkRequest */
        SendMagicLinkRequest: {
            /** Email */
            email: string;
        };
        /** SendMagicLinkResponse */
        SendMagicLinkResponse: {
            /** Success */
            success: boolean;
            /** Message */
            message: string;
        };
        /**
         * SendMessage
         * @description Sends a message to the 'use_web_agent' tool.
         *     Only use this tool if you started an 'use_web_agent' tool and it is currently active.
         *     If you have the information that the 'use_web_agent' tool needs, you are encouraged to use this tool to forward the information to the 'use_web_agent' tool.
         */
        SendMessage: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: SendMessageRole;
            /** Contents */
            contents: string;
            /**
             * Recipient Id
             * @description The id of the 'use_web_agent' tool that you want to send this message to (should be the same as tool_id)
             */
            recipient_id: string;
        };
        /** SendMessageResponse */
        SendMessageResponse: {
            /**
             * Response Role
             * @default send_message
             * @constant
             */
            response_role: "send_message";
            /** Status */
            status: string;
        };
        /** SignupDataPoint */
        SignupDataPoint: {
            /** Date */
            date: string;
            /** Count */
            count: number;
        };
        /**
         * SlackInfo
         * @description Metadata for Slack message drafts.
         */
        SlackInfo: {
            /**
             * Type
             * @default slack
             * @constant
             */
            type: "slack";
            /**
             * Channel Id
             * @description The normalized Slack channel ID for sending messages
             */
            channel_id: string | null;
            /**
             * Channel Name
             * @description Human-readable channel or user name for display purposes
             */
            channel_name: string | null;
            /**
             * Channel Type
             * @description Type of Slack channel: public_channel, private_channel, dm, mpim, etc.
             */
            channel_type: string | null;
        };
        /** SlackNotificationRequest */
        SlackNotificationRequest: {
            /**
             * Main Message
             * @description The main message to send to Slack
             */
            main_message: string;
            /**
             * Comment
             * @description Optional comment to be posted under the main message
             */
            comment: string | null;
            /**
             * Channel
             * @description The Slack channel ID. Defaults to SLACK_ERROR_CHANNEL_ID env variable
             */
            channel: string | null;
            /**
             * Skip If Dev
             * @description If True, messages will not be sent in development environment
             * @default true
             */
            skip_if_dev: boolean;
        };
        /**
         * SlackSendMessage
         * @description Send a message to a Slack channel, DM, or as a reply to an existing message.
         */
        SlackSendMessage: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: SlackSendMessageRole;
            /**
             * Channel
             * @description The channel ID or name to send the message to. For DMs, use the user ID or username seen in slack messages.
             */
            channel: string;
            /**
             * Message
             * @description The message to send. Simple markdown formatting is supported.
             */
            message: string;
            /**
             * Thread Ts
             * @description Optional timestamp of a message to reply to in a thread.
             */
            thread_ts: string | null;
        };
        /**
         * SlackSendMessageResponse
         * @description Response for sending a Slack message.
         */
        SlackSendMessageResponse: {
            /**
             * Response Role
             * @default slack_send_message
             * @constant
             */
            response_role: "slack_send_message";
            /**
             * Success
             * @description Whether the message was sent successfully
             */
            success: boolean;
            /**
             * Message Ts
             * @description The timestamp of the sent message, if successful
             */
            message_ts: string | null;
            /**
             * Error
             * @description Error message if the send failed
             */
            error: string | null;
        };
        /**
         * SnippetMessage
         * @description TODO: legacy, depricated, should be removed in a migration soon.
         */
        SnippetMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: SnippetMessageRole;
            /** Data */
            data: components["schemas"]["Contact"] | components["schemas"]["GoogleCalendarSnippet"];
            action_type: components["schemas"]["SyncActionType"];
            /**
             * Models Id
             * @description What data object to edit
             */
            models_id: string;
            /**
             * Models Name
             * @default messages
             */
            models_name: string;
        };
        /**
         * StrReplaceEditor
         * @description Custom editing tool for viewing, creating and editing files
         *     * State is persistent across command calls and discussions with the user
         *     * If `path` is a file, `view` displays the result of applying `cat -n`. If `path` is a directory, `view` lists non-hidden files and directories up to 2 levels deep
         *     * The `create` command cannot be used if the specified `path` already exists as a file
         *     * If a `command` generates a long output, it will be truncated and marked with `<response clipped>`
         *     * The `undo_edit` command will revert the last edit made to the file at `path`
         *
         *     Notes for using the `str_replace` command:
         *     * The `old_str` parameter should match EXACTLY one or more consecutive lines from the original file. Be mindful of whitespaces!
         *     * If the `old_str` parameter is not unique in the file, the replacement will not be performed. Make sure to include enough context in `old_str` to make it unique
         *     * The `new_str` parameter should contain the edited lines that should replace the `old_str`
         *
         *     Put all your code and files in the `/home/scrapybara/jace` directory.
         */
        StrReplaceEditor: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: StrReplaceEditorRole;
            /**
             * Command
             * @description The commands to run. Allowed options are: `view`, `create`, `str_replace`, `insert`, `undo_edit`.
             * @enum {string}
             */
            command: StrReplaceEditorCommand;
            /**
             * Path
             * @description Absolute path to file or directory, e.g. `/home/scrapybara/jace/file.py`
             */
            path: string;
            /**
             * File Text
             * @description Required parameter of `create` command, with the content of the file to be created.
             */
            file_text: string | null;
            /**
             * Old Str
             * @description Required parameter of `str_replace` command containing the string in `path` to replace.
             */
            old_str: string | null;
            /**
             * New Str
             * @description Optional parameter of `str_replace` command containing the new string (if not given, no string will be added). Required parameter of `insert` command containing the string to insert.
             */
            new_str: string | null;
            /**
             * Insert Line
             * @description Required parameter of `insert` command. The `new_str` will be inserted AFTER the line `insert_line` of `path`.
             */
            insert_line: number | null;
            /**
             * View Range
             * @description Optional parameter of `view` command when `path` points to a file. If none is given, the full file is shown. If provided, the file will be shown in the indicated line number range, e.g. [11, 12] will show lines 11 and 12. Indexing at 1 to start. Setting `[start_line, -1]` shows all lines from `start_line` to the end of the file.
             */
            view_range: number[] | null;
        };
        /** StrReplaceEditorResponse */
        StrReplaceEditorResponse: {
            /** Content */
            content: string;
        };
        /** StreamErrorMessage */
        StreamErrorMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: StreamErrorMessageRole;
            /** Full Message Id */
            full_message_id: string;
        };
        /** SubSyncAction */
        SubSyncAction: {
            /** Id */
            id: string;
            action: components["schemas"]["SyncActionType"];
            /** Data */
            data: {
                [key: string]: unknown;
            } | null;
            /**
             * Models Id
             * @description What data object to edit
             */
            models_id: string;
            /**
             * Models Name
             * @default messages
             */
            models_name: string;
        };
        /**
         * Submit
         * @description Finalize the search process by submitting the relevant snippets from any domain.
         *     The conversation ends immediately after this submission.
         */
        Submit: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: SubmitRole;
            /**
             * Results
             * @description A list of relevant document or message snippets (could come from Gmail, Slack, Notion, local files, etc.).
             */
            results: components["schemas"]["DocumentSpan"][];
        };
        /** SubmitDraftsRequest */
        SubmitDraftsRequest: {
            /**
             * Draft Model Ids
             * @description The `DraftMessage.id` of the drafts to submit. Note: This not the same as the `draft_id`!
             */
            draft_model_ids: string[];
        };
        /** SubmitDraftsResponse */
        SubmitDraftsResponse: {
            /** Tool Ids */
            tool_ids: string[];
        };
        /** SubmitResultsResponse */
        SubmitResultsResponse: {
            /**
             * Response Role
             * @default submit_results
             * @constant
             */
            response_role: "submit_results";
            /** Content */
            content: string;
        };
        /**
         * SubscriptionProductId
         * @enum {string}
         */
        SubscriptionProductId: SubscriptionProductId;
        /**
         * SummaryMessage
         * @description Message that summarizes previous conversation.
         *
         *     There are two ways to target which messages to summarize:
         *     - Using 'index' (legacy): Summarizes messages up to a specific index in the message list
         *     - Using 'target_message_id' (preferred): Summarizes messages up to a specific message ID
         *
         *     When both are provided, 'target_message_id' takes precedence over 'index'.
         *
         *     Important: The message with the target ID (or at the target index) is the boundary
         *     message and is NOT included in the summary. We summarize all messages before the
         *     boundary, while preserving the boundary message and all messages after it. This
         *     ensures we maintain the minimum token count required for context.
         */
        SummaryMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: SummaryMessageRole;
            /** Content */
            content: string;
            /** Index */
            index: number;
            /** Target Message Id */
            target_message_id: string | null;
        };
        /**
         * SyncActionType
         * @enum {string}
         */
        SyncActionType: SyncActionType;
        /**
         * SystemMessage
         * @description Special messages only shown to the model. These have special control
         */
        SystemMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: SystemMessageRole;
            /** Content */
            content: string;
            /** Meta */
            meta: {
                [key: string]: unknown;
            } | null;
        };
        /**
         * SystemUpdateMessage
         * @description An update to the original SystemMessage. Replaces the original meta dict
         */
        SystemUpdateMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: SystemUpdateMessageRole;
            /** Meta */
            meta: {
                [key: string]: unknown;
            } | null;
        };
        /**
         * Text2Im
         * @description Generates an AI generated artistic illustration based on the provided prompt. Only use for artistic purposes. Do not use for plots, charts, or diagrams.
         */
        Text2Im: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: Text2ImRole;
            /** Prompt */
            prompt: string;
        };
        /** Text2ImResponse */
        Text2ImResponse: {
            /**
             * Response Role
             * @default text2im
             * @constant
             */
            response_role: "text2im";
            /** Response Text */
            response_text: string;
        };
        /**
         * Text2ImResponseInfo
         * @description Gives some extra info about the text2im response
         */
        Text2ImResponseInfo: {
            /**
             * Response Role
             * @default text2im
             * @constant
             */
            response_role: "text2im";
            /** Image Url */
            image_url: string | null;
            /** File Uri */
            file_uri: string | null;
        };
        /** Thread */
        Thread: {
            /** Id */
            id: string;
            /** Title */
            title: string | null;
            /** Subtitle */
            subtitle: string | null;
            /** Summary */
            summary: string | null;
            /** Latest Email Summary */
            latest_email_summary: string | null;
            /** Timestamp */
            timestamp: string | null;
            /** Updated */
            updated: string | null;
            /** Major Updated */
            major_updated: string | null;
            status: components["schemas"]["ThreadStatus"] | null;
            email_status: components["schemas"]["EmailThreadStatus"] | null;
            /** Sender Names */
            sender_names: string[] | null;
            /** Unified Uris */
            unified_uris: string[] | null;
            /** Labels */
            labels: string[] | null;
            thread_type: components["schemas"]["ThreadType"] | null;
            /** Snooze Until */
            snooze_until: string | null;
            /** Last Sent At */
            last_sent_at: string | null;
        };
        /** ThreadCreateRequest */
        ThreadCreateRequest: {
            /** Message Id */
            message_id: string | null;
            /** Thread Id */
            thread_id: string | null;
            /** Prompt */
            prompt: string;
            /**
             * Unified Uris
             * @default []
             */
            unified_uris: components["schemas"]["UnifiedUri"][];
            /**
             * Input Widget Responses
             * @default []
             */
            input_widget_responses: (components["schemas"]["PrimitiveInputResponse"] | components["schemas"]["SelectInputResponse"])[];
            /** @default chat */
            thread_type: components["schemas"]["ThreadType"];
        };
        /** ThreadCreateResponse */
        ThreadCreateResponse: {
            /** Id */
            id: string;
        };
        /** ThreadLabelsRequest */
        ThreadLabelsRequest: {
            /**
             * Add Labels
             * @description List of labels to add
             * @default []
             */
            add_labels: string[];
            /**
             * Remove Labels
             * @description List of labels to remove
             * @default []
             */
            remove_labels: string[];
        };
        /**
         * ThreadLockMessage
         * @description Message indicating that a thread is locked for processing
         */
        ThreadLockMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: ThreadLockMessageRole;
        };
        /** ThreadMessageCreateRequest */
        ThreadMessageCreateRequest: {
            /** Id */
            id: string | null;
            /** Message */
            message: string | null;
            /**
             * Unified Uris
             * @default []
             */
            unified_uris: components["schemas"]["UnifiedUri"][];
            /**
             * Input Widget Responses
             * @default []
             */
            input_widget_responses: (components["schemas"]["PrimitiveInputResponse"] | components["schemas"]["SelectInputResponse"])[];
        };
        /** ThreadMessageCreateResponse */
        ThreadMessageCreateResponse: {
            /** Id */
            id: string;
        };
        /** ThreadMessagesGetResponse */
        ThreadMessagesGetResponse: (components["schemas"]["UserMessage"] | components["schemas"]["ToolCallMessage"] | components["schemas"]["NoMoreToolCallsMessage"] | components["schemas"]["ToolResponseMessage"] | components["schemas"]["ToolInProgressMessage"] | components["schemas"]["ToolLoadingMessage"] | components["schemas"]["ToolCallSummaryMessage"] | components["schemas"]["WebAgentProgressMessage"] | components["schemas"]["AssistantTokenMessage"] | components["schemas"]["AssistantMessage"] | components["schemas"]["SystemMessage"] | components["schemas"]["CredentialRequestMessage"] | components["schemas"]["CredentialSuccessMessage"] | components["schemas"]["ApprovalRequestMessage"] | components["schemas"]["ApprovalSuccessMessage"] | components["schemas"]["AutosuggestsMessage"] | components["schemas"]["AssistantCreatedMessage"] | components["schemas"]["LastLengthMessage"] | components["schemas"]["ErrorMessage"] | components["schemas"]["StreamErrorMessage"] | components["schemas"]["ToolCallPreparationMessage"] | components["schemas"]["InputWidgetMessage"] | components["schemas"]["SummaryMessage"] | components["schemas"]["WidgetPreparationMessage"] | components["schemas"]["ReceivedEmailMessage"] | components["schemas"]["EditDraftsMessage"] | components["schemas"]["ReducedEditsMessage"] | components["schemas"]["DraftMessage"] | components["schemas"]["DraftChangeSuggestionMessage"] | components["schemas"]["SystemUpdateMessage"] | components["schemas"]["SnippetMessage"] | components["schemas"]["PartialToolCallMessage"] | components["schemas"]["RelevantConversationMessage"] | components["schemas"]["ToolUpdateMessage"] | components["schemas"]["DraftNotificationMessage"] | components["schemas"]["OutOfCreditsMessage"] | components["schemas"]["ThreadLockMessage"] | components["schemas"]["RuleSuggestionMessage"] | components["schemas"]["MachineMessage"] | components["schemas"]["DraftEmailBodyMessage"])[];
        /**
         * ThreadSnoozeRequest
         * @description Request model for snoozing a thread until a specific time or unsnoozing it.
         */
        ThreadSnoozeRequest: {
            /** Snooze Until */
            snooze_until: string | null;
        };
        /**
         * ThreadStatus
         * @enum {string}
         */
        ThreadStatus: ThreadStatus;
        /**
         * ThreadType
         * @enum {string}
         */
        ThreadType: ThreadType;
        /**
         * ToolCallMessage
         * @description A single tool used by the manager. The tool can be a web agent, quick ai search, etc.
         */
        ToolCallMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: ToolCallMessageRole;
            /** Tool Id */
            tool_id: string;
            /** Tool Call Group Id */
            tool_call_group_id: string;
            /** Tool */
            tool: components["schemas"]["QuickAiSearch"] | components["schemas"]["Text2Im"] | components["schemas"]["UseWebAgent"] | components["schemas"]["SendMessage"] | components["schemas"]["SendEmail"] | components["schemas"]["GoogleCalendarUpsertEvent"] | components["schemas"]["FailedTool"] | components["schemas"]["GoogleCalendarDeleteEvent"] | components["schemas"]["DraftSendEmail"] | components["schemas"]["DraftGoogleCalendarUpsertEvent"] | components["schemas"]["DraftGoogleCalendarDeleteEvent"] | components["schemas"]["DeleteDraft"] | components["schemas"]["GoogleCalendarSchedule"] | components["schemas"]["SearchGmail"] | components["schemas"]["SearchEmailContacts"] | components["schemas"]["DraftUseWebAgent"] | components["schemas"]["ListAgentFiles"] | components["schemas"]["CreateAgentFile"] | components["schemas"]["OpenAgentFile"] | components["schemas"]["EditAgentFile"] | components["schemas"]["DeleteAgentFile"] | components["schemas"]["OpenFile"] | components["schemas"]["SearchFile"] | components["schemas"]["SearchEmails"] | components["schemas"]["Submit"] | components["schemas"]["Wait"] | components["schemas"]["CancelTool"] | components["schemas"]["RecurringActivation"] | components["schemas"]["UpdateLabels"] | components["schemas"]["GetEmailLabels"] | components["schemas"]["SearchNotion"] | components["schemas"]["SearchSlack"] | components["schemas"]["DraftSlackSendMessage"] | components["schemas"]["SlackSendMessage"] | components["schemas"]["ToolLoader"] | components["schemas"]["StrReplaceEditor"] | components["schemas"]["Bash"] | components["schemas"]["LocalToFileUri"] | components["schemas"]["FileUriToLocal"] | components["schemas"]["CodeInterpreter"];
            /**
             * Shown To
             * @default both
             * @enum {string}
             */
            shown_to: ToolCallMessageShown_to;
            /** Draft Id */
            draft_id: string | null;
            /** Models Id */
            models_id: string | null;
        };
        /**
         * ToolCallPreparationMessage
         * @description Indicates that we will do tool calls after this. Since long tool definitions like email can take a long time to be filled completely.
         *     Together with NoMoreToolCallsMessage it encloses all tool calls of a group.
         */
        ToolCallPreparationMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: ToolCallPreparationMessageRole;
            /** Tool Call Group Id */
            tool_call_group_id: string;
        };
        /**
         * ToolCallSummaryMessage
         * @description An ai generated summary of the tool call message
         */
        ToolCallSummaryMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: ToolCallSummaryMessageRole;
            /** Tool Id */
            tool_id: string;
            /** Summary */
            summary: string;
        };
        /** ToolErrorResponse */
        ToolErrorResponse: {
            /**
             * Response Role
             * @default tool_error
             * @constant
             */
            response_role: "tool_error";
            /** Error */
            error: string;
        };
        /**
         * ToolInProgressMessage
         * @description Won't be ever shown in the UI, just to show the model if something hasen't been finished yet.
         */
        ToolInProgressMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: ToolInProgressMessageRole;
            /** Tool Id */
            tool_id: string;
            /** Tool Name */
            tool_name: string;
            /** Content */
            content: string;
            /** Tool Call Group Id */
            tool_call_group_id: string;
        };
        /**
         * ToolLoader
         * @description Loads and unloads tools/tool groups from the agent.
         */
        ToolLoader: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: ToolLoaderRole;
            /**
             * Load Tools
             * @description A list of tools/tool groups that are currently unloaded and that you want to load.
             */
            load_tools: string[];
            /**
             * Unload Tools
             * @description A list of tools/tool groups that are currently loaded and that you want to unload.
             */
            unload_tools: string[];
        };
        /** ToolLoaderResponse */
        ToolLoaderResponse: {
            /**
             * Response Role
             * @default tool_loader
             * @constant
             */
            response_role: "tool_loader";
            /** Status */
            status: string;
        };
        /**
         * ToolLoadingMessage
         * @description Message indicating that tools have been loaded or unloaded.
         */
        ToolLoadingMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: ToolLoadingMessageRole;
            /** Load Tools */
            load_tools: string[];
            /** Unload Tools */
            unload_tools: string[];
        };
        /**
         * ToolResponseMessage
         * @description Follows to the tool call message. i.e. ToolCallMessage 'search for the weather' -> ToolResponseMessage 'The weather is sunny'
         */
        ToolResponseMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: ToolResponseMessageRole;
            /** Tool Id */
            tool_id: string;
            /** Content */
            content: components["schemas"]["UseWebAgentResponse"] | components["schemas"]["QuickAiSearchResponse"] | components["schemas"]["WaitResponse"] | components["schemas"]["SendEmailResponse"] | components["schemas"]["CodeInterpreterResponse"] | components["schemas"]["ScheduledTaskResponse"] | components["schemas"]["Text2ImResponse"] | components["schemas"]["CancelScheduledTaskResponse"] | components["schemas"]["ToolErrorResponse"] | components["schemas"]["CancelToolResponse"] | components["schemas"]["DraftSendEmailResponse"] | components["schemas"]["DraftUseWebAgentResponse"] | components["schemas"]["SearchGmailResponse"] | components["schemas"]["GoogleCalendarScheduleResponse"] | components["schemas"]["GoogleCalendarFreeTimeSlotsResponse"] | components["schemas"]["GoogleCalendarListCalendarsResponse"] | components["schemas"]["DraftGoogleCalendarUpsertEventResponse"] | components["schemas"]["DraftGoogleCalendarDeleteEventResponse"] | components["schemas"]["GoogleCalendarDeleteEventResponse"] | components["schemas"]["GoogleCalendarUpsertEventResponse"] | components["schemas"]["SendMessageResponse"] | components["schemas"]["DeleteDraftResponse"] | components["schemas"]["ListAgentFilesResponse"] | components["schemas"]["CreateAgentFileResponse"] | components["schemas"]["OpenAgentFileResponse"] | components["schemas"]["EditAgentFileResponse"] | components["schemas"]["DeleteAgentFileResponse"] | components["schemas"]["CreatePlanResponse"] | components["schemas"]["PlanStepDoneResponse"] | components["schemas"]["SearchEmailContactsResponse"] | components["schemas"]["OpenFileResponse"] | components["schemas"]["SearchFileResponse"] | components["schemas"]["SearchEmailsResponse"] | components["schemas"]["SubmitResultsResponse"] | components["schemas"]["FailedToolResponse"] | components["schemas"]["UpdateLabelsResponse"] | components["schemas"]["ToolLoaderResponse"] | components["schemas"]["SearchNotionResponse"] | components["schemas"]["NotionPageResponse"] | components["schemas"]["SearchSlackResponse"] | components["schemas"]["DraftSlackSendMessageResponse"] | components["schemas"]["SlackSendMessageResponse"] | components["schemas"]["StrReplaceEditorResponse"] | components["schemas"]["BashResponse"] | components["schemas"]["LocalToFileUriResponse"] | components["schemas"]["FileUriToLocalResponse"] | components["schemas"]["GetEmailLabelsResponse"];
            /** Tool Info */
            tool_info: components["schemas"]["QuickAiSearchResponseInfo"] | components["schemas"]["WebAgentResponseInfo"] | components["schemas"]["SendEmailResponseInfo"] | components["schemas"]["Text2ImResponseInfo"] | components["schemas"]["DraftGoogleCalendarUpsertEventInfo"] | components["schemas"]["GoogleCalendarUpsertEventInfo"] | components["schemas"]["GoogleCalendarDeleteEventInfo"] | null;
            /**
             * Shown To
             * @default both
             * @enum {string}
             */
            shown_to: ToolResponseMessageShown_to;
            /** Draft Id */
            draft_id: string | null;
            /** Models Id */
            models_id: string | null;
        };
        /**
         * ToolUpdate
         * @description A single update step for a tool execution
         */
        ToolUpdate: {
            /** Index */
            index: number;
            /** Update */
            update: string;
            /**
             * Status
             * @enum {string}
             */
            status: ToolUpdateStatus;
        };
        /**
         * ToolUpdateMessage
         * @description Message containing progress updates for tool executions
         */
        ToolUpdateMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: ToolUpdateMessageRole;
            /** Tool Id */
            tool_id: string;
            /** Current State */
            current_state: components["schemas"]["ToolUpdate"][];
        };
        /** TotalSignupsResponse */
        TotalSignupsResponse: {
            /** Total Signups */
            total_signups: components["schemas"]["SignupDataPoint"][];
        };
        /**
         * UnifiedUri
         * @description Practically a FileUri, but doesnt actually point to an r2 bucket.
         *     Instead it points to a virtual folder structure or web URLs.
         *     Built the following way:
         *     integration://scope_value/file_name.file_extension
         *     OR
         *     http(s)://domain.com/path
         *
         *     files://threads/thread_id/file_name.file_extension
         *     files://threads/thread_id/file_name_updated.file_extension -> FileUri user_files://id
         *     hello.pdf -> hello_world.pdf
         *     https://www.shortwave.com -> Web URL
         *
         *     integration - may be "files", "gmail", "slack", "http", "https" etc.
         *     scope_value - depends on integration. For files: "general", "threads", "companies". For gmail: "threads"
         *     For http/https: the domain name
         *
         *     For "files" integration:
         *     We mostly use this to type check the file upload/download process.
         *     A raw r2 upload should not work with UnifiedUri, but work with FileUri.
         *     Convert UnifiedUri to FileUri via convert_unified_uri_to_file_uri(UnifiedUri,user_id)
         *
         *
         *     Emails: gmail://fjdjfnlassdflnl/0/email.md
         *
         *     On thread_ids:
         *     If the scope is "threads", we know that the first part of the path is the thread_id.
         */
        UnifiedUri: string;
        /**
         * UpdateLabels
         * @description Updates labels for one or more threads. Note: Marking emails as done means removing the "INBOX" label. Deleting emails means adding the "TRASH" label.
         */
        UpdateLabels: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: UpdateLabelsRole;
            /**
             * Thread Ids
             * @description List of thread IDs or email IDs to update labels for. Use ['this'] to update the current thread
             */
            thread_ids: string[];
            /**
             * Add Labels
             * @description List of labels to add to the threads
             */
            add_labels: string[];
            /**
             * Remove Labels
             * @description List of labels to remove from the threads
             */
            remove_labels: string[];
        };
        /**
         * UpdateLabelsResponse
         * @description Response from updating labels.
         */
        UpdateLabelsResponse: {
            /**
             * Response Role
             * @default update_labels
             * @constant
             */
            response_role: "update_labels";
            /** Status */
            status: string;
        };
        /** UploadUrlPostRequest */
        UploadUrlPostRequest: {
            /** File Name */
            file_name: string;
            /** Mime Type */
            mime_type: string;
            /** Thread Id */
            thread_id: string | null;
        };
        /** UploadUrlPostResponse */
        UploadUrlPostResponse: {
            /** Url */
            url: string;
            unified_uri: components["schemas"]["UnifiedUri"];
        };
        /**
         * UseWebAgent
         * @description Use for tasks requiring a browser (e.g., setting up accounts, registering, finding specific info, downloading invoices, buying things, checking emails).
         *     The agent can use any website and do anything there.
         *     Usernames and password do not need to be provided, as the web agent will already be logged in.
         *     Provide extremely specific and goal-oriented and concrete task instructions doable in 5 minutes or less.
         *     Focus on what to do and not how to do it.
         *     Task will be done in one go, so make reasonable guesses and ask the user for all necessary information before starting it. (e.g., when filling out a request form you will need to describe all the details that might appear in the form from the user and their contact info in the task.)
         */
        UseWebAgent: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: UseWebAgentRole;
            /** Reasoning */
            reasoning: string;
            /**
             * Task
             * @description Natural-language description of the agent's task. Don't use lists.
             */
            task: string;
            /**
             * File Uris
             * @description URI's of files that the agent will need.
             */
            file_uris: string[];
        };
        /** UseWebAgentResponse */
        UseWebAgentResponse: {
            /**
             * Response Role
             * @default use_web_agent
             * @constant
             */
            response_role: "use_web_agent";
            /** Text Response */
            text_response: string;
            /** Error Message */
            error_message: string | null;
            /** Status */
            status: string;
            /**
             * File Uris
             * @description URI's of files downloaded by the WebAgent. Use only in tool calls.
             */
            file_uris: components["schemas"]["FileUri"][];
            /**
             * Download Links
             * @description Download links of files downloaded by the WebAgent. Use only in AssistantMessage content.
             */
            download_links: string[];
        };
        /**
         * UserMessage
         * @description The message sent by the user.
         */
        UserMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: UserMessageRole;
            /** Content */
            content: string;
            /** Files */
            files: components["schemas"]["UnifiedUri"][] | null;
            /**
             * Image File Uris
             * @description Backend only field, please dont try to use it
             */
            image_file_uris: components["schemas"]["FileUri"][] | null;
            /**
             * Shown To
             * @default both
             * @enum {string}
             */
            shown_to: UserMessageShown_to;
            /**
             * Name
             * @description Who is the sender of this message. Can be browser, system, user. None means that it is the human user.
             */
            name: string | null;
            /**
             * Input Widget Responses
             * @default []
             */
            input_widget_responses: (components["schemas"]["PrimitiveInputResponse"] | components["schemas"]["SelectInputResponse"])[] | null;
        };
        /** ValidationError */
        ValidationError: {
            /** Location */
            loc: (string | number)[];
            /** Message */
            msg: string;
            /** Error Type */
            type: string;
        };
        /** VerifyMagicLinkRequest */
        VerifyMagicLinkRequest: {
            /** Token */
            token: string;
        };
        /** VerifyMagicLinkResponse */
        VerifyMagicLinkResponse: {
            /** Success */
            success: boolean;
            /** Jwt */
            jwt: string;
            /** Message */
            message: string;
        };
        /**
         * Wait
         * @description Use to wait for a specific time before checking on non-tool related tasks. Use only as the last tool.
         */
        Wait: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: WaitRole;
            /** Reasoning */
            reasoning: string;
            /**
             * Minutes
             * @default 0
             */
            minutes: number;
            /**
             * Hours
             * @default 0
             */
            hours: number;
            /**
             * Days
             * @default 0
             */
            days: number;
        };
        /** WaitResponse */
        WaitResponse: {
            /** Minutes */
            minutes: number;
            /** Hours */
            hours: number;
            /** Days */
            days: number;
            /** Time Now */
            time_now: string;
            /** Status */
            status: string;
            /**
             * Response Role
             * @default wait
             * @constant
             */
            response_role: "wait";
        };
        /**
         * WebAgentActionStep
         * @description A single action step of a web agent. Multiple steps can happen between two progress messages.
         */
        WebAgentActionStep: {
            /** Step Number */
            step_number: number;
            /** Reasoning */
            reasoning: string | null;
            /** Screenshot Url */
            screenshot_url: string | null;
            /** Timestamp */
            timestamp: string;
            /** Short Action Description */
            short_action_description: string | null;
            /** Action Type */
            action_type: string | null;
        };
        /**
         * WebAgentProgressMessage
         * @description Message containing the progress and active plan step of a web agent tool
         */
        WebAgentProgressMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: WebAgentProgressMessageRole;
            /** Tool Id */
            tool_id: string;
            /** Steps Done */
            steps_done: number;
            /** Total Steps */
            total_steps: number;
            /**
             * Plan Ready
             * @default false
             */
            plan_ready: boolean;
            /** All Goals */
            all_goals: components["schemas"]["PlanGoalSimple"][];
            /** Current Action Reasoning */
            current_action_reasoning: string | null;
            /**
             * New Action Steps
             * @default []
             */
            new_action_steps: components["schemas"]["WebAgentActionStep"][];
            /**
             * Waiting For Answer
             * @default false
             */
            waiting_for_answer: boolean;
            /** Live Debug Url */
            live_debug_url: string | null;
        };
        /**
         * WebAgentResponseInfo
         * @description Gives some extra info about the web agent response
         */
        WebAgentResponseInfo: {
            /**
             * Response Role
             * @default use_web_agent
             * @constant
             */
            response_role: "use_web_agent";
            /**
             * Web Agent Thread Id
             * @description The thread_id of the the web_agent
             * @default
             */
            web_agent_thread_id: string;
            /**
             * Run Id
             * @description This is a legacy field to keep the object backwards compatible
             */
            run_id: string | null;
        };
        /**
         * WidgetPreparationMessage
         * @description Indicates that we have widgets to show soon.
         */
        WidgetPreparationMessage: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: string | null;
            /** Thread Id */
            thread_id: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            role: WidgetPreparationMessageRole;
            /** Response To Id */
            response_to_id: string;
        };
        /**
         * WritingExample
         * @description Writing example for a user.
         */
        WritingExample: {
            /** Content */
            content: string;
        };
        /**
         * WritingExampleResponse
         * @description Response model for retrieving a writing example.
         */
        WritingExampleResponse: {
            /** Content */
            content: string | null;
        };
        /**
         * EmailContact
         * @description Represents contact information for an email address
         */
        manager__ai_datatypes__EmailContact: {
            /** Name */
            name: string | null;
            /** Email */
            email: string;
            /** One Line Role */
            one_line_role: string | null;
            /** Long Bio */
            long_bio: string | null;
            /**
             * Received Email Count
             * @default 0
             */
            received_email_count: number;
        };
        /**
         * EmailContact
         * @description Pydantic model matching EmailContactsDBModel
         */
        manager__datatypes__EmailContact: {
            /** Id */
            id: string;
            /** Name */
            name: string | null;
            /** Email */
            email: string;
            /** Profile Picture Url */
            profile_picture_url: string | null;
            /**
             * Received Email Count
             * @default 0
             */
            received_email_count: number;
            /** Short Bio */
            short_bio: string | null;
            /** Long Bio */
            long_bio: string | null;
            /** One Line Role */
            one_line_role: string | null;
            /**
             * Created At
             * Format: date-time
             */
            created_at: string;
            /**
             * Updated At
             * Format: date-time
             */
            updated_at: string;
            /** Profile Links */
            profile_links: string[] | null;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    get_signature: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string | null;
                };
            };
        };
    };
    sync_signature: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    draft_suggestion_change: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DraftSuggestionChangeInput"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DraftSuggestionChangeOutput"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_rules: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Rule"][];
                };
            };
        };
    };
    create_rule: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RuleCreate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Rule"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_rule: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                rule_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Rule"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_rule: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                rule_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RuleUpdate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Rule"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_rule: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                rule_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    me_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["APIMeResponse"];
                };
            };
        };
    };
    me_delete: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    me_patch: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["APIMeInput"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["APIMeResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_referral_code: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ReferralCodeInput"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": boolean;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    user_subscription: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["APIUserSubscriptionResponse"];
                };
            };
        };
    };
    free_subscription: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    ping: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    checkers_status: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_inbox_backfill_status: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["InboxBackfillStatusResponse"];
                };
            };
        };
    };
    integrations_get: {
        parameters: {
            query?: {
                redirect_url?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["IntegrationResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_user_custom_instructions: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CustomInstructionsResponse"];
                };
            };
        };
    };
    update_user_custom_instructions: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CustomInstructions"];
            };
        };
        responses: {
            /** @description Successful Response */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_send_as: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["APISendAs"][];
                };
            };
        };
    };
    get_writing_example: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WritingExampleResponse"];
                };
            };
        };
    };
    update_writing_example: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["WritingExample"];
            };
        };
        responses: {
            /** @description Successful Response */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_writing_example: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    get_metadata: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["MetadataResponse"];
                };
            };
        };
    };
    get_calendar_event: {
        parameters: {
            query?: {
                calendar_id?: string | null;
            };
            header?: never;
            path: {
                event_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GoogleCalendarEvent"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_all_messages: {
        parameters: {
            query?: {
                after_timestamp?: string | null;
                limit?: number | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_gmail_email: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                email_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GmailEmailResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_all_threads: {
        parameters: {
            query?: {
                after_timestamp?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Thread"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    thread_create: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ThreadCreateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ThreadCreateResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_all_contacts: {
        parameters: {
            query?: {
                after_timestamp?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["manager__datatypes__EmailContact"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    sync_stream_endpoint: {
        parameters: {
            query?: {
                timestamp?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_read_statuses: {
        parameters: {
            query?: {
                after_timestamp?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReadStatus"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_read_pixel: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                rid: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    data_sync_validation: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DataSyncValidationInput"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DataSyncValidationResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    download_file_get: {
        parameters: {
            query: {
                /** @description The unified URI of the file to download */
                unified_uri_str: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DownloadFileGetResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    file_delete: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DeleteFileDeleteRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DeleteFileDeleteResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    file_metadata_get: {
        parameters: {
            query: {
                /** @description The unified URI of the file to get metadata for */
                unified_uri_str: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FileMetadataGetResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    file_metadata_update: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["FileMetadataUpdateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FileMetadataUpdateResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    thread_upload_url_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UploadUrlPostRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UploadUrlPostResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_labels: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GmailLabel"][];
                };
            };
        };
    };
    create_label: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["GmailLabelCreate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GmailLabel"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_label: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                label_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GmailLabel"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_label: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                label_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_label: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                label_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["GmailLabelUpdate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GmailLabel"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    toggle_zeta_labels_visibility_endpoint: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["GmailLabelVisibilityToggle"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GmailLabel"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    gmail_webhook: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    create_checkout_session: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["APISubscriptionCheckoutSessionInput"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["APISubscriptionSessionUrlResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    buy_subscription: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["APISubscriptionCheckoutSessionInput"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["APISubscriptionSessionUrlResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_billing_portal_session: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["APISubscriptionSessionUrlResponse"];
                };
            };
        };
    };
    stripe_webhook: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    save_credentials: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["APIRequestCredentialInputModel"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["APIRequestCredentialsModel"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_credentials: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["APIGetCredentialsOutput"];
                };
            };
        };
    };
    add_credential: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["APIAddCredentialInput"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["APIAddCredentialOutput"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_credential: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["APIDeleteCredentialInput"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["APIDeleteCredentialOutput"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_credential: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["APIUpdateCredentialInput"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["APIUpdateCredentialOutput"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_jwt_token: {
        parameters: {
            query?: {
                exchange_token?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["APIGetJWTTokenResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_jwt_token_refresh: {
        parameters: {
            query?: {
                token?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["APIGetJWTTokenResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    admin_delete_user: {
        parameters: {
            query?: never;
            header: {
                "x-api-key": string;
            };
            path: {
                user_id_or_email: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    admin_clear_inbox: {
        parameters: {
            query?: never;
            header: {
                "x-api-key": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["APIAdminClearInboxRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    admin_get_env_py: {
        parameters: {
            query?: never;
            header: {
                "x-api-key": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    search_threads: {
        parameters: {
            query?: {
                thread_type?: PathsApiThreadsSearchGetParametersQueryThread_type;
                thread_mode?: PathsApiThreadsSearchGetParametersQueryThread_mode;
                query?: string | null;
                offset?: number;
                limit?: number;
                labels?: string;
                inbox_label?: PathsApiThreadsSearchGetParametersQueryInbox_label;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string[];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    post_init_personality_analysis_thread: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PersonalityAnalysisRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ThreadMessageCreateResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_brief_thread_route: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ThreadCreateResponse"];
                };
            };
        };
    };
    email_reply: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                thread_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["APIEmailReplyInput"];
            };
        };
        responses: {
            /** @description Successful Response */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    forward_email: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                thread_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["APIEmailForwardInput"];
            };
        };
        responses: {
            /** @description Successful Response */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    thread_message_create: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                thread_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ThreadMessageCreateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ThreadMessageCreateResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    thread_toggle_read: {
        parameters: {
            query?: {
                is_read?: boolean;
            };
            header?: never;
            path: {
                thread_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    retry_execute_reply: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                thread_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    edit_drafts: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                thread_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["EditDraftsRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EditDraftsResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    submit_drafts: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                thread_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SubmitDraftsRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SubmitDraftsResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    schedule_send: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                thread_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ScheduleSendRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    change_labels: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                thread_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ThreadLabelsRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    thread_snooze: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                thread_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ThreadSnoozeRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    apply_draft_suggestion: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                thread_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ApplyDraftSuggestionRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    apply_custom_draft_edit: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                thread_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ApplyCustomDraftEditRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    ask_for_context: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                thread_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AskForContextRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    person_essay: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                thread_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PersonEssayRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_threads_by_ids: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["GetThreadsByIdsRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Thread"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    cancel_generation: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                thread_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_all_filter_views: {
        parameters: {
            query?: {
                after_timestamp?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FilterView"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_filter_view: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["FilterViewCreate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FilterView"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_filter_view: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                view_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_filter_view: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                view_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["FilterViewUpdate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FilterView"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reset_filter_views: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    list_ai_filters: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AIFilter"][];
                };
            };
        };
    };
    create_ai_filter: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AIFilterCreate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AIFilter"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_ai_filter: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                filter_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_ai_filter: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                filter_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AIFilterUpdate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AIFilter"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reset_ai_filters: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AIFilter"][];
                };
            };
        };
    };
    integration_connect: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                service_name: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    integration_callback: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                service_name: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    disconnect_integration: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                service_name: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_messages_by_ids: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["GetMessagesByIdsRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_affiliate_stats: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AffiliateStats"];
                };
            };
        };
    };
    get_cumulative_profit: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CumulativeProfitResponse"];
                };
            };
        };
    };
    get_total_signups: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TotalSignupsResponse"];
                };
            };
        };
    };
    get_commission_history: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CommissionHistoryResponse"];
                };
            };
        };
    };
    get_affiliate_user_info: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AffiliateUserInfoResponse"];
                };
            };
        };
    };
    post_login_affiliate_user: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["LoginAffiliateUserRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LoginAffiliateUserResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    post_send_magick_link: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SendMagicLinkRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SendMagicLinkResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    post_verify_magic_link: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VerifyMagicLinkRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["VerifyMagicLinkResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    send_slack_message: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SlackNotificationRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
}
export enum PathsApiThreadsSearchGetParametersQueryThread_type {
    all = "all",
    inbox = "inbox",
    chat = "chat"
}
export enum PathsApiThreadsSearchGetParametersQueryThread_mode {
    agent = "agent",
    all = "all"
}
export enum PathsApiThreadsSearchGetParametersQueryInbox_label {
    all = "all",
    inbox = "inbox",
    non_inbox = "non-inbox"
}
export enum ApprovalRequestMessageRole {
    approval_request = "approval_request"
}
export enum ApprovalSuccessMessageRole {
    approval_success = "approval_success"
}
export enum AssistantCreatedMessageRole {
    assistant_created = "assistant_created"
}
export enum AssistantMessageRole {
    assistant = "assistant"
}
export enum AssistantTokenMessageRole {
    assistant_token = "assistant_token"
}
export enum AutosuggestsMessageRole {
    autosuggests = "autosuggests"
}
export enum BashRole {
    bash = "bash"
}
export enum CancelToolRole {
    cancel_tool = "cancel_tool"
}
export enum CodeInterpreterRole {
    code_interpreter = "code_interpreter"
}
export enum ContactType {
    contact = "contact"
}
export enum CreateAgentFileRole {
    create_agent_file = "create_agent_file"
}
export enum CredentialRequestMessageRole {
    credential_request = "credential_request"
}
export enum CredentialSuccessMessageRole {
    credential_success = "credential_success"
}
export enum DataSyncValidationResponseStatus {
    success = "success",
    mismatch = "mismatch"
}
export enum DeleteAgentFileRole {
    delete_agent_file = "delete_agent_file"
}
export enum DeleteDraftRole {
    delete_draft = "delete_draft"
}
export enum DeleteFileDeleteResponseStatus {
    success = "success",
    failure = "failure"
}
export enum DraftChangeSuggestionMessageRole {
    draft_change_suggestion = "draft_change_suggestion"
}
export enum DraftEmailBodyMessageRole {
    draft_email_body = "draft_email_body"
}
export enum DraftGoogleCalendarDeleteEventRole {
    draft_google_calendar_delete_event = "draft_google_calendar_delete_event"
}
export enum DraftGoogleCalendarUpsertEventRole {
    draft_google_calendar_upsert_event = "draft_google_calendar_upsert_event"
}
export enum DraftGoogleCalendarUpsertEventRsvp_response {
    accepted = "accepted",
    declined = "declined",
    tentative = "tentative"
}
export enum DraftMessageRole {
    draft_message = "draft_message"
}
export enum DraftNotificationMessageRole {
    draft_notification = "draft_notification"
}
export enum DraftSendEmailRole {
    draft_send_email = "draft_send_email"
}
export enum DraftSlackSendMessageRole {
    draft_slack_send_message = "draft_slack_send_message"
}
export enum DraftStatus {
    READY = "READY",
    RUNNING = "RUNNING",
    FINISHED = "FINISHED",
    DELETED = "DELETED",
    FAILED = "FAILED",
    DELETED_BY_SYSTEM = "DELETED_BY_SYSTEM",
    SCHEDULED = "SCHEDULED"
}
export enum DraftUseWebAgentRole {
    draft_use_web_agent = "draft_use_web_agent"
}
export enum EditAgentFileRole {
    edit_agent_file = "edit_agent_file"
}
export enum EditDraftsMessageRole {
    edit_drafts = "edit_drafts"
}
export enum EmailThreadStatus {
    no_agent = "no_agent",
    working = "working",
    draft_ready = "draft_ready",
    draft_edited = "draft_edited",
    draft_deleted = "draft_deleted",
    sent_response = "sent_response",
    archived = "archived"
}
export enum ErrorMessageRole {
    error = "error"
}
export enum ErrorMessageError_type {
    ratelimit = "ratelimit",
    overloaded = "overloaded"
}
export enum FailedToolRole {
    failed_tool = "failed_tool"
}
export enum FileUriToLocalRole {
    file_uri_to_local = "file_uri_to_local"
}
export enum FilterViewKind {
    zeta = "zeta",
    user_defined = "user-defined"
}
export enum GetEmailLabelsRole {
    get_email_labels = "get_email_labels"
}
export enum GoogleCalendarDeleteEventRole {
    google_calendar_delete_event = "google_calendar_delete_event"
}
export enum GoogleCalendarEventRsvp_response {
    accepted = "accepted",
    declined = "declined",
    tentative = "tentative"
}
export enum GoogleCalendarScheduleRole {
    google_calendar_schedule = "google_calendar_schedule"
}
export enum GoogleCalendarScheduleSchedule_type {
    full = "full",
    free = "free",
    summary = "summary"
}
export enum GoogleCalendarSnippetRsvp_response {
    accepted = "accepted",
    declined = "declined",
    tentative = "tentative"
}
export enum GoogleCalendarSnippetType {
    google_calendar_event = "google_calendar_event"
}
export enum GoogleCalendarUpsertEventRole {
    google_calendar_upsert_event = "google_calendar_upsert_event"
}
export enum GoogleCalendarUpsertEventRsvp_response {
    accepted = "accepted",
    declined = "declined",
    tentative = "tentative"
}
export enum InboxBackfillStatusResponseStatus {
    not_started = "not_started",
    in_progress = "in_progress",
    finished = "finished",
    failed = "failed",
    starting = "starting",
    error = "error",
    waitlist = "waitlist",
    dead = "dead",
    agent_running = "agent_running"
}
export enum InputWidgetMessageRole {
    input_widgets = "input_widgets"
}
export enum LastLengthMessageRole {
    last_message_index = "last_message_index"
}
export enum ListAgentFilesRole {
    list_agent_files = "list_agent_files"
}
export enum LocalToFileUriRole {
    local_to_file_uri = "local_to_file_uri"
}
export enum MachineMessageRole {
    machine = "machine"
}
export enum NoMoreToolCallsMessageRole {
    no_more_tool_calls = "no_more_tool_calls"
}
export enum OpenAgentFileRole {
    open_agent_file = "open_agent_file"
}
export enum OpenFileRole {
    open_file = "open_file"
}
export enum OutOfCreditsMessageRole {
    out_of_credits = "out_of_credits"
}
export enum PartialToolCallMessageRole {
    partial_tool_call = "partial_tool_call"
}
export enum PrimitiveInputRoleRole {
    primitive_input = "primitive_input"
}
export enum PrimitiveInputRoleType {
    string = "string",
    number = "number"
}
export enum QuickAiSearchRole {
    quick_ai_search = "quick_ai_search"
}
export enum ReceivedEmailMessageRole {
    received_email = "received_email"
}
export enum RecurringActivationRole {
    recurring_activation = "recurring_activation"
}
export enum ReducedEditsMessageRole {
    reduced_edits = "reduced_edits"
}
export enum RelevantConversationMessageRole {
    relevant_conversation = "relevant_conversation"
}
export enum RuleRule_status {
    active = "active",
    draft = "draft"
}
export enum RuleSuggestionMessageRole {
    rule_suggestion = "rule_suggestion"
}
export enum RuleUpdateRule_status {
    active = "active",
    draft = "draft"
}
export enum SearchEmailContactsRole {
    search_email_contacts = "search_email_contacts"
}
export enum SearchEmailsRole {
    search_emails = "search_emails"
}
export enum SearchFileRole {
    search_file = "search_file"
}
export enum SearchGmailRole {
    search_gmail = "search_gmail"
}
export enum SearchNotionRole {
    search_notion = "search_notion"
}
export enum SearchSlackRole {
    search_slack = "search_slack"
}
export enum SelectInputRoleRole {
    select_input = "select_input"
}
export enum SendEmailRole {
    send_email = "send_email"
}
export enum SendMessageRole {
    send_message = "send_message"
}
export enum SlackSendMessageRole {
    slack_send_message = "slack_send_message"
}
export enum SnippetMessageRole {
    snippet = "snippet"
}
export enum StrReplaceEditorRole {
    str_replace_editor = "str_replace_editor"
}
export enum StrReplaceEditorCommand {
    view = "view",
    create = "create",
    str_replace = "str_replace",
    insert = "insert",
    undo_edit = "undo_edit"
}
export enum StreamErrorMessageRole {
    stream_error = "stream_error"
}
export enum SubmitRole {
    submit = "submit"
}
export enum SubscriptionProductId {
    free = "free",
    free_yearly = "free_yearly",
    professional = "professional",
    professional_yearly = "professional_yearly",
    premium = "premium",
    premium_yearly = "premium_yearly"
}
export enum SummaryMessageRole {
    message_summary = "message_summary"
}
export enum SyncActionType {
    I = "I",
    D = "D",
    U = "U",
    A = "A",
    S = "S"
}
export enum SystemMessageRole {
    system = "system"
}
export enum SystemUpdateMessageRole {
    system_update = "system_update"
}
export enum Text2ImRole {
    text2im = "text2im"
}
export enum ThreadLockMessageRole {
    thread_lock = "thread_lock"
}
export enum ThreadStatus {
    idle = "idle",
    in_progress = "in_progress",
    failed = "failed",
    paused = "paused",
    completed = "completed",
    out_of_turns = "out_of_turns",
    deleted = "deleted"
}
export enum ThreadType {
    inbox = "inbox",
    chat = "chat",
    inbox_overview = "inbox_overview"
}
export enum ToolCallMessageRole {
    tool_call = "tool_call"
}
export enum ToolCallMessageShown_to {
    only_client = "only_client",
    only_model = "only_model",
    both = "both"
}
export enum ToolCallPreparationMessageRole {
    tool_call_preparation = "tool_call_preparation"
}
export enum ToolCallSummaryMessageRole {
    tool_call_summary = "tool_call_summary"
}
export enum ToolInProgressMessageRole {
    tool_in_progress = "tool_in_progress"
}
export enum ToolLoaderRole {
    tool_loader = "tool_loader"
}
export enum ToolLoadingMessageRole {
    tool_loading = "tool_loading"
}
export enum ToolResponseMessageRole {
    tool_response = "tool_response"
}
export enum ToolResponseMessageShown_to {
    only_client = "only_client",
    only_model = "only_model",
    both = "both"
}
export enum ToolUpdateStatus {
    done = "done",
    not_done = "not_done"
}
export enum ToolUpdateMessageRole {
    tool_update = "tool_update"
}
export enum UpdateLabelsRole {
    update_labels = "update_labels"
}
export enum UseWebAgentRole {
    use_web_agent = "use_web_agent"
}
export enum UserMessageRole {
    user = "user"
}
export enum UserMessageShown_to {
    only_client = "only_client",
    only_model = "only_model",
    both = "both"
}
export enum WaitRole {
    wait = "wait"
}
export enum WebAgentProgressMessageRole {
    web_agent_progress = "web_agent_progress"
}
export enum WidgetPreparationMessageRole {
    widget_preparation = "widget_preparation"
}
